/* eslint-disable no-nested-ternary */
/* eslint-disable no-restricted-syntax */
import React from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';
// import LazyLoad from 'react-lazy-load';
import AdCaller from 'helpers/ads/adCaller';
import WithGeo from 'helpers/ads/WithGeo';
import PropTypes from 'prop-types';
import Sidebar from 'components_v2/desktop/Sidebar';
import { bindGa, gaWrapper } from 'helpers/analytics';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import ErrorBoundary from 'components/ErrorBoundary';
import smoothScroll from 'smoothscroll';
import Links from 'components/Link';
import _get from 'lodash.get';
import {
  getSkipAdsFlagForVideo,
  getMsidFromPath,
  isTablet,
  // setViewedArticleMsidsInLocalStorage,
  //checkInlineTemplate,
} from 'utils/common';
import { runAbExperiment } from 'utils/experimentUtils';
import fetchExperimentRhs from 'utils/rhsExperimentUtil';
import {
  getURLwithTag,
  getMSPGA,
  convertCDataAnchorTagsForOrganic,
  isOrganicArticle,
  convertCDataAnchorTagsForPaidTraffic,
  getPaidReferrer,
  getAmazonLogoByCountry,
  getKeyword,
  getOnClickWindowFuntion,
} from 'routes/articleshow_v2/utils/mspUtils';
import NextArticlesLHSv2 from 'routes/articleshow_v2/components/desktop/NextArticlesLHS/NextArticlesLHSv2';
import InfoGraphicMobile from 'components/InfoGraphicMobile/InfoGraphicMobile';
import { setSaleNudgeVisibility } from 'reduxUtils/modules/affiliates';
// import { ArticleshowWidget } from 'components/Elections2019';
// import LiveblogInsert from 'components/LiveblogInsert';
import WithCommentLoader from 'modules/WithComments/WithCommentLoader';
import { sendGaThroughProps } from 'helpers/analytics/sendGaThroughProps';
// import IFrameWdt from 'components_v2/common/IFrameWdt';
// import PercentageComponents from 'routes/articleshow/PercentageComponents';
import CData from 'components_v2/common/CData';
import PhotoSliderWrappr from 'components_v2/desktop/PhotoSliderWrappr/PhotoSliderWrappr';
import ElementInView from 'components_v2/common/ElementInView';
//import PollWidget from 'components_v2/common/PollWidget';
import BackToBrandwire from 'components/BackToBrandwire';
import AffiliatesContent from 'components/AffiliatesContent';
import AffiliatesContentV2 from 'components/AffiliatesContentV2';
import AffiliatesProductPanel from 'components_v2/common/AffiliateProductPanel';
import BreadCrumb from 'components_v2/common/BreadCrumb/BreadCrumb';
import { loadAllAdsFromQueue } from 'helpers/ads/redux';
import { getEncodedAffiliateLink } from 'utils/Affiliate';
import { processPerpectualATFadSticky } from 'helpers/ads/AdObserver';
import Accordion from 'components_v2/common/Accordion';
// import Cookie from 'utils/cookies';
import ImageV2 from 'components_v2/common/ImageV2';
// import TitleBoxSkeleton from 'routes/games/components/common/DailyPuzzles/TitleBoxSkeleton/TitleBoxSkeleton';
import LoginAccount from '../../components/common/LoginAccount';
// import AmazonNSA from '../../components/common/AmazonNativeAds/AmazonNSA';
import Text from '../../components/common/Text';
import Image from '../../components/common/Image';
import Polls from '../../components/common/Polls';
import linkRelInCrypto from '../../utils/zebpayUtil';
//import VideoWidget from '../../components/common/VideoWidget/VideoWidget';
import Quotes from '../../components/common/Quotes';
// import TimesPointHeaderWidget from '../../components/desktop/TimesPointHeaderWidget';
import LeadImageOrVideo from '../../components/common/LeadImageOrVideo';
import Byline from '../../components/common/Byline';
import EmailPrintFontOptions from '../../components/common/EmailPrintFontOptions';
import ReadInOtherLanguage from '../../components/common/ReadInOtherLanguage/ReadInOtherLanguage';
import BrandwireComments from '../../components/common/BrandwireComments';
// import ArticleshowBriefs from '../../components/common/ArticleshowBriefs/WithArticleshowBriefs';
import Synopsis from '../../components/common/Synopsis/index';
import Keyhighlights from '../../components/common/Keyhighlights/index';
import LinksList from '../../../../components_v2/desktop/LinksList';
import Mocktale from '../../components/common/Mocktale/Mocktale';
// import AffiliateWidgetMain from '../../components/common/AffiliateWidget/AffiliateWidgetMain';
import sidebarMapping, { firstNonAdWidget } from './SidebarMapping';
// import ReadAlsoBootomWidget from '../../components/common/ReadAlsoBottomWidget/ReadAlsoBottomWidgetLoader';
import s from './Articleshow_v2.scss';
//import DailyPuzzles from '../../../games/components/common/DailyPuzzles/DailyPuzzlesLoader';
// import MidArticleSearch from '../../../../components_v2/desktop/MidArticleSearch/MidArticleSearch';
// import NewscardComponent from '../../../../components_v2/common/InitNewscardComponents/LoadableNewsCardComponent';
// import {
//   getTopicTreeApi,
//   getSubSecApi,
// } from '../../../../components_v2/common/InitNewscardComponents/CardConfig/apiConfig';
import WithVisualStories from '../../../home/components/desktop/VisualStories/VisualStories';
// import BlockedNotificationCard from '../../../../components_v2/common/BlockedNotificationCard';
import LoadableComponentLoader from '../../../../components_v2/common/LoadableComponentLoader/LoadableComponentLoader';
import {
  TOI_DOMAIN,
  TWITTER_EMBED_SCRIPT,
  IMAGE_URL,
  //LIVE_SCORE_CARD_API,
} from '../../../../constants/index';
import JumpLinksTable from '../../components/common/JumpLinksTable/JumpLinksTable';
import TrendingSlider from '../../../../components_v2/desktop/TrendingSlider/TrendingSlider';
import RenderInserts from '../../../home/components/desktop/RenderInsertsV2/RenderInserts';
// import TimesAssist from '../../../../components_v2/common/TimesAssist/TimesAssist';
import { getGeoCountry } from '../../../../utils/primeUtil';
import SummarizedStory from '../../components/common/SummarizedStory/SummarizedStory';
import InViewObserver from '../../../../components/InViewObserver/InViewObserver';
import PersonaliseWidget from '../../../../components_v2/common/PersonaliseWidget/PersonaliseWidget';
import PersonaliseWidgetWithPoll from '../../../../components_v2/common/PersonaliseWidgetWithPoll/PersonaliseWidgetWithPoll';
import DPLink from '../../../../components_v2/common/Dpanda/DPLink';
import VideoSliderWrapper from '../../../../components_v2/common/VideoSlider/VideoSliderWrapper';
import PollWidgetWapper from '../../../../components_v2/common/PollWidget/PollWidgetWapper';
import ProductSliderWrapper from '../../../../components_v2/common/ProductSliderWrapper/ProductSliderWrapper';
// import ElectionWidgetMainWrapper from '../../../../components/ElectionV2/ElectionWidgetMainWrapper/ElectionWidgetMainWrapper';

function getWebUrl(url) {
  if (typeof window === 'undefined') {
    return url;
  }
  const origin = `${window.location.protocol}//${window.location.hostname}${
    window.location.port ? `:${window.location.port}` : ''
  }`;
  const updatedUrl = url.replace('https://timesofindia.indiatimes.com', origin);
  return updatedUrl;
}

function getInactiveArticleClass({ reason }) {
  // the conditions would need to be uncommented in future if more handling is needed KV
  switch (reason) {
    // case 'INACCURATE':
    //   return 'innaccurate';
    // case 'LEGAL_ISSUES':
    //   return 'legal_issues';
    // case 'Not Applicable':
    //   return 'not_applicable';
    // default:
    //   return 'unavailable';
    default:
      return 'innaccurate';
  }
}

class ArticleshowInner extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      adsPositions: {},
      //textSize: 9,
      showFullArticle: false,
      showTwitterShareArticleContent: false,
      shareOffsetLeft: 0,
      shareOffsetTop: 0,
      shareText: '',
      // #TODO: Make it dynamic after feed integration
      shareLink: '',
      showBackToText: false,
      // this flag prevents full Article reading
      // showMrecOnShowFullArticle: false, //Show mrec on click of show full article button
      // showOutstreamad: false,
      showSocialWidget: false,
      isReadMore: false,
      isReadNextGrxPageViewFired: {},
      onScrollScripts: new Set(),
      viewGA4summarizedstory: false,
      // stopAutoPlay: false,
    };
    this.articleshowRef = React.createRef();
    this.articleBodyRef = React.createRef();
    this.atfDivRef = null;
    this.commentTextInput = React.createRef();
    this.brCount = 0;
    this.totalBrCount = 0;
    this.getWidgetComponent = {
      cricketscorecard: LoadableComponentLoader,
      inline_videos_slider: VideoSliderWrapper,
    };
    this.readalsoGA4Fired = false;
    this.summarizedstoryGA4Fired = false;
    this.cardComponent1Rendered = false;
    this.cardComponent2Rendered = false;
    this.articleId = '';
    this.isVisualStoryRendered = false;
    this.timespointRef = React.createRef();
    this.videoWidgetCount = 0;
    this.readNextconfigTriggered = false;
    this.etimesFoodSectionMsid = '64732371';
    this.totalStoryCount =
      props.articleData && Array.isArray(props.articleData.story)
        ? props.articleData.story.length
        : 0;
    this.personaliseApiTriggered = React.createRef(false);
  }

  componentDidMount() {
    const {
      articleData,
      isPerpetual,
      loadRelatedArticlesOnPerpetual,
      loadPerpetualsInView,
      // isUserPrime,
      // msid,
      // isWapView,
      // activeMsid,
    } = this.props;
    if (
      !loadPerpetualsInView &&
      typeof loadRelatedArticlesOnPerpetual === 'function'
    ) {
      loadRelatedArticlesOnPerpetual();
    }
    // const grxId = Cookie.get('_grx');
    //const navSubsecTion = _get(articleData, 'navsubsecs');
    const articleId = _get(articleData, 'id');
    this.articleId = articleId;
    // if (this.props.isUserPrime) {
    //   if (topicTreeMetaData || navSubsecTion) {
    //     // eslint-disable-next-line react/prop-types
    //     this.props.getCardsData({
    //       articleId,
    //       metaDataApi: getTopicTreeApi(topicTreeMetaData),
    //       subSectionApi: getSubSecApi(navSubsecTion),
    //     });
    //   }
    // }

    const { abAdskey, abTestExperimentId } = this.props;
    const { abTestAsRhsId = '' } = abTestExperimentId || {};
    if (isPerpetual) this.updateVideoWidgetForPerpetual();

    if (this.props.isMspArticle && getPaidReferrer()) {
      convertCDataAnchorTagsForPaidTraffic();
    } else if (this.props.isMspArticle && isOrganicArticle()) {
      convertCDataAnchorTagsForOrganic();
    }

    runAbExperiment(abTestAsRhsId, abAdskey, {
      1: fetchExperimentRhs.bind(this),
    });
    document.addEventListener('click', this.handleDocumentClickEvent);
    if (this.isUnavailableArticle()) {
      document.title = 'This article has been removed';
    }
    this.setState({ componentMounted: true });
    // this.listenWebStickyAtf();
    if (!this.props.isUserPrime && this.props.articleIndex && this.atfDivRef) {
      processPerpectualATFadSticky(this.atfDivRef);
    }

    this.checkNewsWireArticles();
    if (this.props.isMspArticle) {
      window.mspPlatform = this.mspPlatform;
    }
    this.setOnScrollScripts();

    if (
      articleData &&
      !(articleData.videoss && articleData.videoss.length === 0) &&
      Array.isArray(articleData.images) &&
      articleData.images.length > 1
    ) {
      sendGaThroughProps({
        data: {
          gaCategory: 'WEB-TOI-Articlehsow',
          gaAction: 'Swipe - Lead Image Group',
          gaLabel: articleData.images.length,
          nonInteraction: true,
        },
      });
    }
    // Performance related code revert
    // if (this.props.perpetual && grxId) {
    //   const params = {
    //     contentPrimeStatus: 'non-prime',
    //     userPrimeStatus: isUserPrime ? 'prime' : 'non-prime',
    //     msid,
    //     isWapView,
    //     section: this.getSectionName() || '',
    //     subsection: _get(this.props.articleData?.navsubsecs, 'subsec2', ''),
    //     activeMsid,
    //   };
    //   this.props.loadpageLevelData(params);
    // }
  }

  getSubsectionUrl = () => {
    const { location } = this.props;
    const urlPathParams = location.split('/');
    if (urlPathParams.indexOf('articleshow') > -1) {
      const articleShowIndex = urlPathParams.indexOf('articleshow');
      const subSection = urlPathParams
        .splice(0, articleShowIndex - 1)
        .join('/');
      return subSection;
    }
    return null;
  };

  componentDidUpdate(prevProps) {
    // Performance related code revert
    // const grxId = Cookie.get('_grx');
    // if (
    //   !this.props.perpetual &&
    //   grxId &&
    //   !this.personaliseApiTriggered.current
    // ) {
    //   this.personaliseApiTriggered.current = true;
    //   const { isUserPrime, msid, isWapView, activeMsid } = this.props;
    //   const params = {
    //     contentPrimeStatus: 'non-prime',
    //     userPrimeStatus: isUserPrime ? 'prime' : 'non-prime',
    //     msid,
    //     isWapView,
    //     section: this.getSectionName() || '',
    //     subsection: _get(this.props.articleData.navsubsecs, 'subsec2', ''),
    //     activeMsid,
    //   };
    //   this.props.loadpageLevelData(params);
    // }

    if (this.props.articleData && this.props.articleData.ads) {
      this.props.loadAllAdsFromQueue('', window.location.pathname);
    }

    if (
      !prevProps.hasFixedHeading &&
      this.props.hasFixedHeading &&
      !this.showNextArticlePopUpViewGAFired
    ) {
      const { articleData } = this.props;
      const categoryForGA =
        typeof window !== 'undefined' && window.categoryForSearchGA
          ? window.categoryForSearchGA
          : '';
      if (articleData) {
        sendGaThroughProps({
          data: {
            gaCategory: `${categoryForGA}`,
            gaAction: 'Widget-Up_Next-View',
          },
        });

        this.showNextArticlePopUpViewGAFired = true;
      }
    }
  }
  atfAdCode = () => {
    const {
      isMspArticle,
      isAdRemoved,
      atfDivAD,
      msid,
      articleIndex,
    } = this.props;
    if (
      atfDivAD &&
      articleIndex > 0 &&
      !isMspArticle &&
      !isAdRemoved &&
      !isTablet()
    ) {
      return (
        <div
          className={`${s.ad_fixplaceholder}`}
          ref={myRef => {
            this.atfDivRef = myRef;
          }}
        >
          <AdCaller
            deviceType=""
            data={{
              name: 'masthead',
              ...atfDivAD,
              articleIndex: this.props.articleIndex,
              divId: `${atfDivAD.divId}-${msid}`,
              targetingInfo: {
                ..._get(this.props.articleData, `ads.dfp.info`, {}),
              },
            }}
            className={`${s.mobile_ads_spacing} ${
              s.atf_ad_perpetual
            } atf_ad_perpetual`}
            immediateLoad
          />
        </div>
      );
    }
    return null;
  };
  /* end ATF sticky logic start */
  componentWillUnmount() {
    document.removeEventListener('click', this.handleDocumentClickEvent);
  }

  updateVideoWidgetForPerpetual() {
    const { sidebarData, msid } = this.props;
    if (sidebarData?.data?.length > 0) {
      for (let i = 0; i < sidebarData.data.length; i += 1) {
        if (
          sidebarData?.data[i]?.name === 'video_widget' &&
          sidebarData?.data[i]?.dataUrl.split('&msid=').length > 1
        ) {
          sidebarData.data[i].dataUrl = `${
            sidebarData?.data[i]?.dataUrl.split('&msid=')[0]
          }&msid=${msid}`;
          this.setState({ experimentSidebarData: sidebarData });
        }
      }
    }
  }

  getMsid = () => {
    if (typeof window !== 'undefined') {
      return getMsidFromPath(window.location.href);
    }

    return '';
  };

  checkNewsWireArticles() {
    const { perpetual } = this.props;
    const frmapp = this.props.isAppView;
    try {
      const { referrer } = document;
      if (
        (!perpetual &&
          (referrer &&
            typeof referrer === 'string' &&
            referrer.indexOf('https://www.mediawire.in') !== -1)) ||
        frmapp
      ) {
        this.setState({ showBackToText: true });
      }
    } catch (e) {
      // console.log(e);
    }
  }

  checkCountOfReadAlsoStory = msid => {
    const articleStory = this.props.articleData && this.props.articleData.story;
    const readAlsoStroyData = articleStory.filter(
      story => story.tn === 'readalso',
    );
    let counter = 0;
    if (readAlsoStroyData instanceof Array && readAlsoStroyData.length > 0) {
      readAlsoStroyData.forEach((data, index) => {
        if (data.contents[0].msid === msid) {
          counter = index + 1;
        }
      });
    }
    return counter;
  };
  checkCountOfVideoWidget = msid => {
    const articleStory = this.props.articleData && this.props.articleData.story;
    const videoWigets = articleStory.filter(
      story => story.tn === 'inlinevideo',
    );
    let counter = 0;
    if (videoWigets instanceof Array && videoWigets.length > 0) {
      videoWigets.forEach((data, index) => {
        if (data.id === msid) {
          counter = index + 1;
        }
      });
    }
    return counter;
  };
  handleDocumentClickEvent = () => {
    if (this.state.showTwitterShareArticleContent) {
      this.setState({ showTwitterShareArticleContent: false });
    }
  };
  isUnavailableArticle() {
    // this function returns if the article is taken down article and helps in hiding some items
    if (
      typeof this.props.articleData.status === 'string' &&
      this.props.articleData.status.toLowerCase() === 'unavailable'
    ) {
      return true;
    }
    return false;
  }

  // onSizeChange = currSize => {
  //   this.setState({
  //     textSize: currSize,
  //   });
  // };
  getCommentModerationData() {
    return _get(this.props.articleData, 'metaInfo.CommentModeration', '');
  }

  @bindGa({})
  // openNICOverlay(event, text) {
  //   disableBodyScroll();
  //   const url = event.target.getAttribute('data-href');
  //   const isActive = this.props.isNicOpen && this.props.activeNicUrl === url;
  //   if (isActive) {
  //     //if the clicked nic is active
  //     this.props.toggleNIC(false);
  //   } else if (this.props.isNicOpen) {
  //     //if nic is open then only load the data
  //     this.props.loadNIC(url);
  //     this.props.setNICLabel(text);
  //   } else {
  //     this.props.toggleNIC(true);
  //     this.props.loadNIC(url);
  //     this.props.setNICLabel(text);
  //   }
  // }
  selectText = e => {
    const event = e || window.event;
    const tthis = e.currentTarget;
    const settings = {
      pos: 'right',
      shareBoxWidth: 20,
      minusOffsetTop: 35,
      shortUrl: '',
    };
    let text = null;
    if (window.getSelection) {
      text = window.getSelection().toString();
    } else if (document.selection && document.selection.type !== 'Control') {
      text = document.selection.createRange().text;
    }
    //Remove space
    text = text.replace(/^\s+|\s+$/gm, '');
    if (typeof text === 'string' && text.length > 0) {
      // window.sharetext = text;
      const offsettop =
        event.pageY -
        (window.pageYOffset + tthis.getBoundingClientRect().top) -
        settings.minusOffsetTop;
      let offsetleft =
        parseInt(event.nativeEvent.offsetX, 10) - settings.minusOffsetTop;
      if (settings.pos === 'left') {
        offsetleft = parseInt(tthis.offset().left - settings.shareBoxWidth, 10);
      } else {
        offsetleft =
          parseInt(event.nativeEvent.offsetX, 10) - settings.shareBoxWidth;
      }

      setTimeout(() => {
        this.setState({
          showTwitterShareArticleContent: true,
          shareOffsetLeft: offsetleft,
          shareOffsetTop: offsettop,
          shareText: text.substring(0, 140),
          shareLink: `${this.props.articleData.su} via @${
            this.props.articleData.twtHandle
          }`,
        });
      }, 10);
    }
  };

  shareSelectedText = () => {
    let content = this.state.shareText;
    const link = this.state.shareLink;
    const linkLen = link.length;
    const msgMaxLimit = 133 - linkLen;
    if (content.length > msgMaxLimit) {
      content = `${content.substring(0, 130 - linkLen)}...`;
    }

    window.open(
      `https://twitter.com/intent/tweet?text=${encodeURIComponent(
        content,
      )} - ${link}&original_referer=https://${
        window.location.hostname
      }/share.cms`,
      'socialPost',
      'width=600,height=230,left=383,top=249,scrollbars=0,resizable=false',
    );
  };

  getSectionName() {
    const sectionName =
      this.props.articleData.navsubsecs &&
      this.props.articleData.navsubsecs.subsec1 &&
      this.props.articleData.navsubsecs.subsec1.subsecname1
        ? this.props.articleData.navsubsecs.subsec1.subsecname1
        : '';

    return sectionName;
  }

  getHighlightsInsert(data) {
    let highlightedHtml;
    if (data) {
      highlightedHtml = (
        <div className="hltsinsert">
          <React.Fragment>
            {data.title &&
              data.title instanceof Array &&
              data.title.length > 0 && (
                <h5 className={s.highlightedheading}>{data.title[0].value}</h5>
              )}
            {data.items &&
              data.items instanceof Array &&
              data.items.map((val, index) => (
                <div className={s.mosthighlighted}>
                  <span className={s.stamp}>{index + 1}</span>
                  {val.title.length > 0 ? <h3>{val.title}</h3> : ''}
                  <div>
                    {val.value instanceof Array &&
                      val.value.map((valueItem, valueIndex) =>
                        this.getComponents(
                          valueItem,
                          valueIndex,
                          this.props.articleData,
                        ),
                      )}
                  </div>
                </div>
              ))}
          </React.Fragment>
        </div>
      );
    }
    return highlightedHtml;
  }
  toggleReadNextGrxViewFired = position => {
    this.setState({
      isReadNextGrxPageViewFired: {
        ...this.state.isReadNextGrxPageViewFired,
        [position]: true,
      },
    });
  };
  setOnScrollScripts() {
    const articleStory = this.props.articleData && this.props.articleData.story;
    let cdataScrollScripts = new Set();
    const cdataItems =
      articleStory && Array.isArray(articleStory)
        ? articleStory.filter(story => story.tn === 'cdata')
        : [];
    cdataItems.forEach(item => {
      if (item?.type?.toLowerCase() === 'twitter') {
        cdataScrollScripts.add(TWITTER_EMBED_SCRIPT);
      } else if (item.scripts) {
        cdataScrollScripts = new Set([...cdataScrollScripts, ...item.scripts]);
      }
    });
    this.setState({
      onScrollScripts: cdataScrollScripts,
    });
  }

  getContentADs = data => (
    <>
      {data?.name === 'mgid_second_mrec' && <div className="js_tbl_2ad" />}
      <AdCaller
        key={`${data?.name}${this.props.articleIndex}`}
        className={s.outstreamad}
        pauseAdCall={this.props.blocked !== -1}
        skipReRender
        adWapperClass={`${data?.name}_parent`}
        data={{
          ...data,
          articleIndex: this.props.articleIndex,
          articleVideo: this.props.articleData?.videos?.length > 0,
        }}
        msid={this.props.msid}
      />
    </>
  );

  getComponents(data, key, articleshowData) {
    // if (data && data.tn === 'slider') {
    // }
    const componentState = this.state;
    const { componentMounted } = this.state;
    const { isWapView } = this.props;
    let component = '';
    const hindsightAdObj = {
      adCode: _get(articleshowData, 'ads.dfp.slots.HINDSIGHT.adCode'),
      size: _get(articleshowData, 'ads.dfp.slots.HINDSIGHT.size'),
      divId: _get(articleshowData, 'ads.dfp.slots.HINDSIGHT.divId'),
    };
    const subsec3name = _get(articleshowData, 'navsubsecs.subsec3.subsecname3');
    const subsec4name = _get(articleshowData, 'navsubsecs.subsec4.subsecname4');
    const subsecmsid2 = _get(articleshowData, 'navsubsecs.subsec2.subsecmsid2');
    const linkRel =
      data.rel || linkRelInCrypto(subsecmsid2, articleshowData.dl);
    const gaLabel = `${subsec3name ? `${subsec3name}_` : ''}${
      subsec4name ? `${subsec4name}_` : ''
    }${this.id}`;
    const platform = this.props.isAppView ? 'APP' : 'WEB';
    this.mspPlatform = platform;
    this.mspGaLabel = gaLabel;
    const skipPersonalizationWidget = !this.props.isUserLoggedin;
    const isAstrologyArticle =
      _get(this.props.articleData, 'navsubsecs.subsec1.subsecmsid1') ===
      '65857041';
    const isReligionArticle =
      _get(articleshowData, 'navsubsecs.subsec1.subsecmsid1') === '79795437';
    const isEducationArticle =
      _get(articleshowData, 'navsubsecs.subsec1.subsecmsid1') === '93114663';
    const isBusinessArticle =
      _get(articleshowData, 'navsubsecs.subsec1.subsecmsid1') === '1898055';

    const isWebSeriesArticle =
      _get(articleshowData, 'navsubsecs.subsec1.subsecmsid1') === '65854450';
    const isEntertainmentArticle =
      _get(articleshowData, 'navsubsecs.subsec1.subsecmsid1') === '1081479906';
    const isLifeStyleArticle =
      _get(articleshowData, 'navsubsecs.subsec1.subsecmsid1') === '2886704';
    const isTVArticle =
      _get(articleshowData, 'navsubsecs.subsec1.subsecmsid1') === '27975577';
    const isEtimesTrendingArticle =
      _get(articleshowData, 'navsubsecs.subsec2.subsecmsid2') === '97575790';

    const isForcePollSection =
      isWebSeriesArticle ||
      isEntertainmentArticle ||
      isLifeStyleArticle ||
      isTVArticle ||
      isEtimesTrendingArticle;

    const isNewListStyleEnabled =
      isAstrologyArticle ||
      isReligionArticle ||
      isEducationArticle ||
      this.props.isEtimesArticle ||
      isBusinessArticle;

    const isBrAtFirstIndex =
      _get(this.props.articleData, 'story[0].tn') === 'br';

    if (data.tn) {
      switch (data.tn) {
        case 'iframe': {
          const datad = {
            name: '',
            tn: data.tn,
            dataUrl: data.dataUrl,
            height: data.height,
          };
          component = <RenderInserts data={[datad]} key={data.id} />;
          break;
        }
        case 'text':
          component = (
            <React.Fragment>
              {componentState.adsPositions.length !== 0 &&
                componentState.adsPositions[key] &&
                componentState.adsPositions[key].isPrepend &&
                componentState.adsPositions[key].adComponent}
              <Text
                value={data.value}
                pos={key}
                styleObj={s}
                isWapView={isWapView}
                tags={data.tags}
                forceSpan={this.isUnavailableArticle()}
                jumpLinkId={data.cmsannotationId}
                stpPrpgtnAndPrvDflt
              />
              {componentState.adsPositions.length !== 0 &&
                componentState.adsPositions[key] &&
                !componentState.adsPositions[key].isPrepend &&
                componentState.adsPositions[key].adComponent}
            </React.Fragment>
          );

          break;
        case 'link':
          if (this.props.blocked !== -1) {
            component = (
              <Text
                value={data.value}
                pos={key}
                styleObj={s}
                isWapView={isWapView}
                tags={data.tags}
                forceSpan={this.isUnavailableArticle()}
              />
            );
          } else if (this.props.isMspArticle) {
            const {
              tag,
              wu = '',
              affiliateName,
              notAffiliateLink = false,
              textElementType = '',
            } = data;

            const linkComponent = (
              <Links
                rel={data.rel}
                isMspArticle
                to={getURLwithTag(
                  wu,
                  tag,
                  this.props.isOrganic,
                  this.props.isPaidTraffic,
                )}
                styleObj={s}
                target="_blank"
                ga4Data={[
                  {
                    event: 'user_click',
                    type: 'affiliate_hyperlink',
                    category: 'inline_link',
                    label: notAffiliateLink
                      ? `AS1_${articleshowData.wu}`
                      : `${affiliateName}_${data.value}`,
                  },
                ]}
                forceTargetBlank
              >
                {data.value}
              </Links>
            );

            component =
              textElementType === 'h5' ? (
                <span className={s.bold_underline}>{linkComponent}</span>
              ) : (
                linkComponent
              );
          } else {
            const checkHtml = /(<([^>]+)>)/i;
            const htmlStatus = checkHtml.test(data.value);
            //const inlineTemplate = checkInlineTemplate(data.wu);
            component = htmlStatus ? (
              <Links
                rel={linkRel}
                to={data.wu}
                styleObj={s}
                className={data.tags || ''}
                target={data?.target}
                skipAffiliateHandling={articleshowData.ag === 'Mediawire'}
                // data-ga={`Click-Hyperlink|${inlineTemplate}-${data.value}-${
                //   data.wu
                // }`}
                dangerouslySetInnerHTML={{
                  __html: `${data.value}`,
                }}
              />
            ) : (
              <Links
                rel={linkRel}
                to={data.wu}
                styleObj={s}
                className={data.tags || ''}
                skipAffiliateHandling={articleshowData.ag === 'Mediawire'}
                target={data?.target}
                // data-ga={`Click-Hyperlink|${inlineTemplate}-${data.value}-${
                //   data.wu
                // }`}
              >
                {data.value}
              </Links>
            );
          }
          break;
        case 'document':
          if (data.type === 'pdf' && data && data.wu) {
            component = (
              <LoadableComponentLoader
                loadOnScroll
                loadableComponentName="PdfEmbed"
                feedPdfCountUrl={data.wu}
                imageUrl={data.imageUrl}
                msid={data.msid}
                title={data.value}
                isWapView={false}
              />
            );
          }
          break;
        case 'keyword':
          if (this.props.blocked !== -1) {
            component = (
              <Text
                value={data.value}
                pos={key}
                styleObj={s}
                isWapView={isWapView}
                tags={data.tags}
                forceSpan={this.isUnavailableArticle()}
              />
            );
          } else {
            component = (
              <Links
                to={data.wu}
                styleObj={s}
                className={data.tags || ''}
                //data-ga={`Click-Hyperlink|link_topic-${data.value}-${data.wu}`}
              >
                {data.value}
              </Links>
            );
          }

          break;
        case 'br':
          this.brCount += 1;
          if (
            this.brCount === 5 &&
            this.props.isSportsBeaconJs &&
            !this.props.isPerpetual
          ) {
            component = (
              <>
                <br />
                <LoadableComponentLoader
                  loadOnScroll
                  loadableComponentName="PixelEmbedVideo"
                  msid={this.props.msid}
                />
              </>
            );
          } else if (
            isLifeStyleArticle &&
            ((!isBrAtFirstIndex && this.brCount === 2) ||
              (isBrAtFirstIndex && this.brCount === 3))
          ) {
            const { articleData: { story = [] } = {} } = this.props;
            const renderCustomPartnerBanner = story.find(
              storyItem => storyItem.tn === 'toi_custom_partner_banner',
            );
            if (!renderCustomPartnerBanner) {
              component = <br />;
              break;
            }
            const sectionl1 = _get(
              articleshowData,
              'navsubsecs.subsec1.subsecnameseo1',
            );
            component = (
              <>
                <br />
                <div id="affilaite_cpb_banner_v2" className={this.brCount}>
                  <AffiliatesContentV2
                    type="toi_custom_partner_banner"
                    client="affiliates"
                    showWidgetOnPrimeToo
                    filters={{
                      pagename: 'articleshow',
                      sectionl1,
                    }}
                    componentProps={{}}
                  />
                </div>
                <br />
              </>
            );
          } else {
            component = <br />;
          }

          break;
        case 'inlineimage':
          component = (
            <>
              <Image
                title={data.title}
                caption={data.cap}
                // url={data.wu}
                target={data.target}
                altTitle={data.title}
                msid={data.imageId}
                imagesize={data.imagesize}
                overridelink={data.wu}
                styleObj={s}
                key={key}
                skipAffiliateHandling={articleshowData.ag === 'Mediawire'}
              />
              {componentState.adsPositions.length !== 0 &&
                componentState.adsPositions[key] &&
                !componentState.adsPositions[key].isPrepend &&
                componentState.adsPositions[key].adComponent}
            </>
          );
          break;
        case 'inlinevideo': {
          const isVideoSkipAds = getSkipAdsFlagForVideo(
            articleshowData.metaInfo,
          );
          this.videoWidgetCount = this.videoWidgetCount + 1;
          component = (
            <div className={s.inarticlevdo_wrapper}>
              <LoadableComponentLoader
                loadableClass="inliveVideoHeight"
                loadInView
                loadableComponentName="VideoWidget"
                posKey={this.checkCountOfVideoWidget(data.id)}
                video={data}
                isVideoSkipAds={isVideoSkipAds}
                styleObj={s}
                playerContainerId={`playerContainer_${data.id}_inline`}
                iconClassName={s.as_playicon}
                imageClassName={`${s.inline_photo} ${s.content}`}
                videoClassName={`${s.content}`}
                isWapView={isWapView}
                isUserPrime={this.props.isUserPrime}
                notitle
                videoTheatreSliderData={this.props.videoTheatreSliderData}
                addNextVideoMsid={this.props.addNextVideoMsid}
                enableNextVideos
                dataFirstPlayClickGa={`video-inline-user_initiated|msid_${
                  articleshowData.id
                }-video_${data && data.id ? data.id : ''}`}
                dataCloseClickGa={`video-inline-close_video|msid_${
                  articleshowData.id
                }-video_${data && data.id ? data.id : ''}`}
                isInline
                showMiniTvPlayer={this.props.showMiniTvPlayer}
                loadedMiniTvComponent={this.props.loadedMiniTvComponent}
                lazyLoadYoutubeVid
                placeHolderStyles={
                  data?.playerType === 'youtube' || data?.playerType === 'slike'
                    ? { minHeight: '290px' }
                    : null
                }
              />
              {componentState.adsPositions.length !== 0 &&
                componentState.adsPositions[key] &&
                !componentState.adsPositions[key].isPrepend &&
                componentState.adsPositions[key].adComponent}

              <p className={s.inlinevdo_heading}>{data.hl}</p>
            </div>
          );
          break;
        }
        case 'cdata': {
          let cdataClassName;
          if (this.props.isMspArticle) {
            cdataClassName = 'modify_cdata_style';
          }
          if (isNewListStyleEnabled) {
            cdataClassName = 'modify_cdata_list_style';
          }
          component = (
            <>
              {componentState.adsPositions.length !== 0 &&
                componentState.adsPositions[key] &&
                componentState.adsPositions[key].isPrepend &&
                componentState.adsPositions[key].adComponent}
              <CData
                styleObj={s}
                isJumpLinkParent={!!data.cmsannotationId}
                value={data.value}
                type={data.type}
                pos={key}
                disableUnscape={this.props.isMspArticle}
                className={cdataClassName}
                applyLazyLoadLogic
              />
              {componentState.adsPositions.length !== 0 &&
                componentState.adsPositions[key] &&
                !componentState.adsPositions[key].isPrepend &&
                componentState.adsPositions[key].adComponent}
            </>
          );
          if (data.tags && data.tags.includes('strong')) {
            component = <strong>{component}</strong>;
          }
          break;
        }
        case 'quote':
          component = <Quotes styleObj={s} {...data} />;
          break;
        case 'extquote':
          component = <Quotes styleObj={s} {...data} />;
          break;
        case 'slideshow':
          component = (
            <LoadableComponentLoader
              {...data}
              isWapView={isWapView}
              // title={this.props.articleData.hl}
              wu={getWebUrl(this.props.articleData.wu)}
              query={this.props.query}
              loadInView
              loadableComponentName="Slideshow"
              placeHolderStyles={{ minHeight: '600px' }}
            />
          );
          break;
        case 'times_assist':
          if (
            (this.props.isUserPrime || this.props.isUserLoggedin) &&
            getGeoCountry() === 'IN'
          ) {
            component = (
              <ErrorBoundary>
                <div className={s.timesAssistBox}>
                  <LoadableComponentLoader
                    loadInView
                    loadableComponentName="TimesAssist"
                    {...data}
                    pageUrl={this.props.articleData.wu}
                    isUserLoggedin={this.props.isUserLoggedin}
                    isUserPrime={this.props.isUserPrime}
                    isArticleshow
                  />
                </div>
              </ErrorBoundary>
            );
          }
          break;
        case 'readalso':
          if (!skipPersonalizationWidget) {
            component = (
              <PersonaliseWidget
                card="readAlso"
                section={this.getSectionName() || ''}
                subsection={_get(
                  this.props.articleData?.navsubsecs?.subsec2,
                  'subsecname2',
                  '',
                )}
                msid={this.props.msid}
                template="AS"
                contentprimestatus="non-prime"
                userprimestatus={this.props.isUserPrime ? 'prime' : 'non-prime'}
                styleObj={{ minHeight: '330.06px' }}
                classname="readalsoshimmer"
                disableWidget={this.props.isMspArticle}
                ga4Type="newforyou"
              />
            );
          }
          break;
        case 'banner_insert':
          if (!(data.imageUrl || data.bannerImageMsid)) {
            return null;
          }

          component = (
            <InViewObserver
              inViewCallback={() => {
                analyticsWrapper('ga4', {
                  event: 'user_shown',
                  type: data.ga4Type,
                  category: data.ga4Category,
                });
              }}
              className={s.bannerInsert}
            >
              <Links
                target="_blank"
                to={data.wu}
                onClick={() => {
                  analyticsWrapper('ga4', {
                    event: 'user_click',
                    type: data.ga4Type,
                    category: data.ga4Category,
                  });
                }}
              >
                <ImageV2
                  src={
                    data.imageUrl ||
                    `${IMAGE_URL}/photo/${data.bannerImageMsid}.cms`
                  }
                  alt="Banner Insert"
                  lazyload
                />
              </Links>
            </InViewObserver>
          );
          break;
        case 'pollwidget':
          // perosnalize widget with poll to be removed along with pollwidget
          if (
            isForcePollSection &&
            this.props.forcePollShow &&
            this.props.forcePollShow === '1' &&
            this.isValidToShowInBetweenContent() &&
            data &&
            data.categorytabs !== 'No Poll'
          ) {
            component = (
              <PollWidgetWapper
                dataUrl={data.dataUrl}
                key={`${data.tn}_${key}`}
                isLoggedIn={this.props.isUserLoggedin}
                toggleLoginBox={this.props.showLogin}
                ga4Type={data?.ga4Type}
                ga4Category={data?.ga4Category}
                height="209px"
                hideShareFeature
                sectionName={this.props?.sectionName}
              />
            );
          } else if (
            data &&
            data.embedStories &&
            Array.isArray(data.embedStories) &&
            data.embedStories.length > 0
          ) {
            component = (
              <PersonaliseWidgetWithPoll
                card="readAlso"
                msid={this.props.msid}
                template="AS"
                contentprimestatus="non-prime"
                userprimestatus={this.props.isUserPrime ? 'prime' : 'non-prime'}
                styleObj={{ minHeight: '330.06px' }}
                classname="readalsoshimmer"
                disableWidget={this.props.isMspArticle}
                stories={data.embedStories}
              />
            );
          } else if (
            this.isValidToShowInBetweenContent() &&
            data &&
            (!data.embedStories || data.embedStories === '') &&
            data.categorytabs !== 'No Poll'
          ) {
            component = (
              <PollWidgetWapper
                dataUrl={data.dataUrl}
                key={`${data.tn}_${key}`}
                isLoggedIn={this.props.isUserLoggedin}
                toggleLoginBox={this.props.showLogin}
                ga4Type={data?.ga4Type}
                ga4Category={data?.ga4Category}
                hideShareFeature
                height="209px"
                sectionName={this.props.sectionName}
              />
            );
          }
          break;
        case 'summarizedstory':
          if (!this.summarizedstoryGA4Fired) {
            analyticsWrapper('ga4', {
              event: 'component_load',
              type: 'articleshow_extended_related_stories',
            });
            this.summarizedstoryGA4Fired = true;
          }
          component = (
            <InViewObserver
              inViewCallback={() => {
                if (!this.state.viewGA4summarizedstory) {
                  analyticsWrapper('ga4', {
                    event: 'user_shown',
                    type: 'articleshow_extended_related_stories',
                  });
                  this.setState({ viewGA4summarizedstory: true });
                }
              }}
              className={s.summarizedStory}
            >
              <SummarizedStory
                value={data.value}
                su={data.su}
                syn={data.syn}
                msid={data.msid}
              />
            </InViewObserver>
          );
          break;
        case 'poll':
          component = (
            <Polls
              isWapView={isWapView}
              {...data}
              isUserLoggedin={this.props.isUserLoggedin}
              showLogin={this.props.showLogin}
            />
          );
          break;
        case 'widget': {
          const Widget = this.getWidgetComponent[data.type];
          if (Widget) {
            if (data.type === 'cricketscorecard') {
              component = (
                <Widget
                  {...data}
                  isWapView={isWapView}
                  keyId={key}
                  loadOnScroll
                  loadableComponentName="CricketScorecard"
                />
              );
            } else {
              component = (
                <Widget {...data} isWapView={isWapView} keyId={key} />
              );
            }
          }
          break;
        }
        case 'jarvisAd':
          if (this.isThisArticleAdActive() && this.props.articleIndex !== 1) {
            component =
              data?.name === 'mgid_second_mrec' ? (
                <InViewObserver
                  inViewCallback={() => {
                    analyticsWrapper('ga4', {
                      event: 'user_scroll',
                      type: `scroll-depth`,
                      category: 'articleshow_scroll',
                      label: 'article_taboola_mid_article',
                    });
                  }}
                  viewMargin="1px 0px 1px 0px"
                >
                  {this.getContentADs(data)}
                </InViewObserver>
              ) : (
                this.getContentADs(data)
              );
          }
          break;
        // case 'exitpolltable': {
        //   if (
        //     this.props.exitPollData &&
        //     this.props.exitPollData.items &&
        //     this.props.exitPollData.items.length
        //   ) {
        //     component = (
        //       <ArticleshowWidget
        //         exitPollData={this.props.exitPollData}
        //         exitPoll
        //       />
        //     );
        //   }

        //   break;
        // }
        // case 'resulttable': {
        //   if (
        //     this.props.electionsData &&
        //     this.props.electionsData.items &&
        //     this.props.electionsData.items.srcdata &&
        //     this.props.electionsData.items.srcdata.length
        //   ) {
        //     component = (
        //       <ArticleshowWidget electionsData={this.props.electionsData} />
        //     );
        //   }
        //   break;
        // }
        case 'openinappbanner':
          component = null;
          break;
        case 'inlineAd': {
          const adObject = _get(articleshowData, data.ref, {});
          const newAdObject = {
            ...adObject,
            divId: `${adObject.divId}-${articleshowData.id}`,
          };
          component = (
            <AdCaller
              className={s.mobile_ads_spacing}
              data={newAdObject}
              pauseAdCall={this.props.blocked !== -1}
            />
          );
          break;
        }
        // case 'lbinsert': {
        //   if (this.props.perpetual) {
        //     component = (
        //       <LazyLoad offsetVertical={500} debounce={false}>
        //         <LiveblogInsert
        //           data={data}
        //           isWapView={this.props.isWapView}
        //           theme="asv2insert"
        //         />
        //       </LazyLoad>
        //     );
        //   } else {
        //     component = (
        //       <LiveblogInsert
        //         data={data}
        //         isWapView={this.props.isWapView}
        //         theme="asv2insert"
        //       />
        //     );
        //   }

        //   break;
        // }

        case 'NewsList_NewsCoverage': {
          component = (
            <LoadableComponentLoader
              loadInView
              loadableComponentName="NewsCoverage"
              isWapView={this.props.isWapView}
              dataUrl={data.wu}
            />
          );
          break;
        }
        case 'hindsight_ad_code': {
          component = (
            <WithGeo
              render={({ geoCountry }) => {
                const country =
                  typeof geoCountry === 'string'
                    ? geoCountry.toUpperCase()
                    : '';
                if (country !== 'IN' && hindsightAdObj.adCode) {
                  return (
                    <AdCaller
                      pauseAdCall={this.props.blocked !== -1}
                      className={s.hindsight}
                      data={hindsightAdObj}
                      deviceType="all"
                    />
                  );
                }
                return null;
              }}
            />
          );
          break;
        }
        // case 'slider': {
        //   component = (
        //     <WithGeo
        //       render={({ geoCountry }) => {
        //         const country =
        //           typeof geoCountry === 'string'
        //             ? geoCountry.toUpperCase()
        //             : '';
        //         if (country === 'IN' && componentMounted) {
        //           return this.getAsBriefs();
        //         }
        //         return null;
        //       }}
        //     />
        //   );
        //   break;
        // }
        case 'opinion_poll': {
          component = (
            <WithGeo
              render={({ geoCountry }) => {
                const country =
                  typeof geoCountry === 'string'
                    ? geoCountry.toUpperCase()
                    : '';
                if (country === 'IN' && componentMounted) {
                  return this.getOpinionPoll();
                }
                return null;
              }}
            />
          );
          break;
        }
        // case 'ipl_mid_article': {
        //   component =
        //     componentMounted &&
        //     this.props.isIPLMidArticleWidgetPresent &&
        //     this.props.getIPLMidArticleWidgets(articleshowData);
        //   break;
        // }
        case 'timeline': {
          // if (data.type === 'hltsinsert') {
          component = this.getHighlightsInsert(data);
          // }
          break;
        }
        case 'jumpLinksTable': {
          component = <JumpLinksTable data={data} />;
          break;
        }
        case 'affiliate_product_panel': {
          const { affiliateName, index, title, sectionl1 = '' } = data;
          const {
            navsubsecs: { subsec3: { subsecnameseo3 } = {} } = {},
          } = this.props.articleData;

          component = (
            <AffiliatesProductPanel
              data={data}
              isAppView={this.props.isAppView}
              handleOrganic
              isPaidTraffic={this.props.isPaidTraffic}
              isMspUSPage={this.props.isMspUSPage}
              keyword={_get(
                articleshowData,
                'metaInfo.Amazonaffiliatesproduct',
              )}
              componentProps={{
                config: {
                  affiliateName,
                  useGA4: true,
                  ga4: {
                    type: 'affiliate_widget',
                    category: 'inarticle',
                    story_no: index,
                    subsection: sectionl1,
                    subsection2: subsecnameseo3,
                    label: `${affiliateName}_${title}`,
                    // subsection2: subsec3name,
                  },
                },
                data: {
                  withHeading: title,
                },
              }}
            />
          );
          break;
        }
        case 'affiliate_product_inlineImage': {
          const {
            navsubsecs: { subsec3: { subsecnameseo3 = '' } = {} } = {},
          } = this.props.articleData;
          const {
            linkTag,
            widgetTag,
            title,
            data: {
              caption,
              imageURL = '',
              affiliatename,
              url = '',
              sectionl1,
            } = {},
            index,
          } = data;

          let widgetURL = getURLwithTag(
            url,
            widgetTag,
            this.props.isOrganic,
            this.props.isPaidTraffic,
          );
          const dataGA = getMSPGA(platform, gaLabel, affiliatename, 'object');

          if (url) {
            widgetURL = getEncodedAffiliateLink('', widgetURL, false, true);
          }
          const logoURLObj =
            affiliatename === 'amazon'
              ? { logoURL: getAmazonLogoByCountry() }
              : {};
          component = widgetURL ? (
            <>
              {data.isNewArticle && (
                <Links
                  to={getURLwithTag(
                    url,
                    linkTag,
                    this.props.isOrganic,
                    this.props.isPaidTraffic,
                  )}
                  forceTargetBlank
                  isMspArticle
                  target="_blank"
                  data-ga={`${dataGA.category}|${dataGA.action +
                    (index ? `_${index}` : '')}|${dataGA.label}${
                    data.title ? `_${data.title}` : ''
                  }`}
                  rel="nofollow"
                >
                  <h2 className={s.aff_subheading}>{data.title}</h2>
                </Links>
              )}
              <AffiliatesContent
                enableWidgetsOnLoad
                inViewClass={data.isNewArticle ? s.msp_new_inline_image : ''}
                type={`product_widget_inline_image${
                  this.props.isMspUSPage ? '_us' : ''
                }`}
                handlePaidTraffic
                filters={{
                  pagename: 'articleshow',
                  affiliateName: affiliatename,
                }}
                componentProps={{
                  config: {
                    useGA4: true,
                    affiliateName: 'amazon',
                    ga4: {
                      type: 'affiliate_widget',
                      category: 'inarticle',
                      story_no: index,
                      subsection: sectionl1,
                      subsection2: subsecnameseo3,
                      label: `${affiliatename || 'amazon'}_${title}`,
                    },
                  },
                  data: {
                    ...data.data,
                    title,
                    url: widgetURL,

                    ...logoURLObj,
                  },
                }}
              />
            </>
          ) : (
            <>
              <Image
                title={data.title}
                url={imageURL}
                altTitle={data.title}
                styleObj={s}
              />
              {caption && <p>{caption}</p>}
            </>
            // <image title={data.title} src={imageURL} alt={data.title} />
          );
          break;
        }

        case 'affiliate_multi_product_panel_inline_image': {
          component = (
            <AffiliatesProductPanel
              data={data}
              isAppView={this.props.isAppView}
              handleOrganic
              isPaidTraffic={this.props.isPaidTraffic}
              isMspUSPage={this.props.isMspUSPage}
              componentProps={{
                config: {
                  affiliateName: data.affiliateName,
                  useGA4: true,
                  ga4: {
                    type: 'affiliate_widget',
                    category: 'inarticle',
                    // subsection2: subsec3name,
                  },
                },
              }}
            />
          );
          break;
        }
        // TODO: Election Widget
        // case 'electionwdt': {
        //   return (
        //     <ErrorBoundary>
        //       <InViewObserver
        //         inViewCallback={() => {
        //           analyticsWrapper('ga4', {
        //             event: 'user_shown',
        //             type: `exitpoll_widget`,
        //           });
        //         }}
        //       >
        //         <ElectionWidgetMainWrapper
        //           isWapView
        //           isPowerByAd={this.props?.isPowerByAd}
        //           isPowerByAdActive={this.props?.isPowerByAdActive}
        //           tabs={this.props?.electionTabs}
        //           hideStarCandidate
        //           hideLiveblog
        //           hideHeading
        //           hideSharing
        //           hideTitle
        //           hideInfocus
        //           hideDisplayText
        //           hidePowerStates
        //           isInnerWidget
        //           hideETheading
        //         />
        //       </InViewObserver>
        //     </ErrorBoundary>
        //   );
        // }
        case 'sup':
          component = <sup>{data.value}</sup>;
          break;
        case 'sub':
          component = <sub>{data.value}</sub>;
          break;
        case 'also_published':
          component = <div className={s.alsoPublished}>{data.value}</div>;
          break;
        case 'custom_partner_banner': {
          component = (
            <AffiliatesContentV2
              type="msp_custom_partner_banner"
              client="affiliates"
              showWidgetOnPrimeToo
              filters={{
                sectionl1: data.sectionl1,
                sectionl2: subsec4name,
              }}
              componentProps={{
                data: {
                  ga: {
                    label: `Inbody_${gaLabel}`,
                  },
                },
              }}
            />
          );
          break;
        }
        case 'dpanda_inline_link': {
          const { data: dpData = {}, needLeftSpace = false } = data || {};
          component = <DPLink {...{ needLeftSpace }} data={dpData} />;
          break;
        }
        default:
          component = '';
      }
    }
    return [component];
  }

  renderFactsheetLayout(story, articleshowData) {
    let headline = [];
    let accContent = [];
    const leadImageText = [];
    const finalHtml = [];
    let inlinecontent = [];
    let headlineIndex = 0;
    for (let i = 0; i < story.length; i += 1) {
      if (headlineIndex && story[i].value?.indexOf('<h2>') > -1) {
        finalHtml.push({
          headline,
          content: accContent,
          nonaccContent: inlinecontent,
        });
        headline = [];
        accContent = [];
        inlinecontent = [];
      }
      if (story[i].tn === 'cdata' && story[i].value?.indexOf('<h2>') > -1) {
        headline.push(this.getComponents(story[i], i, articleshowData));
        headlineIndex += 1;
      } else if (
        (story[i].tn === 'cdata' && story[i].value?.indexOf('<h6>') > -1) ||
        inlinecontent?.length
      ) {
        inlinecontent.push(this.getComponents(story[i], i, articleshowData));
      } else if (headlineIndex) {
        accContent.push(this.getComponents(story[i], i, articleshowData));
      } else {
        leadImageText.push(this.getComponents(story[i], i, articleshowData));
      }
      if (i === story.length - 1) {
        finalHtml.push({
          headline,
          content: accContent,
          nonaccContent: inlinecontent,
        });
      }
    }
    let renderAccordion = finalHtml.length > 0;
    if (
      renderAccordion &&
      finalHtml.length === 1 &&
      finalHtml[0].headline.length === 0 &&
      finalHtml[0].content.length === 0 &&
      finalHtml[0].nonaccContent.length === 0
    ) {
      renderAccordion = false;
    }
    return (
      <div className={s.qnaLayout}>
        {leadImageText}
        {renderAccordion && (
          <>
            <div className={s.accGuide}>
              <img
                className={s.infoIcon}
                src="https://static.toiimg.com/photo/93323395.cms"
                alt=""
              />
              Tap to expand and read more
            </div>
            <Accordion
              data={finalHtml}
              onChange={() => {
                gaWrapper(
                  'send',
                  'event',
                  'factsheet',
                  'accordian_click',
                  this.props.msid,
                );
              }}
            />
          </>
        )}
      </div>
    );
  }
  openSidebar = msid => {
    this.props.openSidebar(msid);
  };

  getCoronaPhotoCarousel = () => {
    const { widgets } = this.props.articleData;
    if (widgets) {
      for (let i = 0; i < widgets.length; i += 1) {
        if (widgets[i].tn === 'health_fitness_carousel') {
          return (
            <ErrorBoundary>
              <PhotoSliderWrappr sectionData={widgets[i]} />
            </ErrorBoundary>
          );
        } else if (widgets[i].tn === 'ipl_carousel_pgwdt') {
          return (
            <ErrorBoundary>
              <PhotoSliderWrappr
                sectionData={widgets[i]}
                gaSecName="IPL Photos"
              />
            </ErrorBoundary>
          );
        } else if (widgets[i].tn === 'PhotoStories_widget') {
          return (
            <ErrorBoundary>
              <ElementInView
              // gaAction="view-photostories"
              // gaLabel={subSecSeoLocation}
              >
                <PhotoSliderWrappr
                  sectionData={widgets[i]}
                  slidesToShow={4}
                  draggableSlider
                  enableBottomArrows
                  isFromEtimesAS={this.props.isEtimesArticle}
                />
              </ElementInView>
            </ErrorBoundary>
          );
        }
      }
    }
    return null;
  };

  getNewsCoverage = () => {
    const { widgets } = this.props.articleData;
    if (widgets) {
      for (let i = 0; i < widgets.length; i += 1) {
        if (widgets[i].tn === 'news_coverage') {
          return (
            <>
              <LoadableComponentLoader
                loadInView
                loadableComponentName="NewsCoverage"
                isWapView={this.props.isWapView}
                dataUrl={widgets[i].wu}
              />;
            </>
          );
        }
      }
    }
    return null;
  };

  getOpinionPoll = () => {
    const { widgets } = this.props.articleData;
    let returnHtml = null;
    if (widgets) {
      for (let i = 0; i < widgets.length; i += 1) {
        if (widgets[i].tn === 'opinion_poll') {
          returnHtml = (
            <LoadableComponentLoader
              loadInView
              loadableComponentName="PollWidget"
              dataUrl={widgets[i].wu}
              hideShareFeature
              key={widgets[i].tn}
              isLoggedIn={this.props.isUserLoggedin}
              toggleLoginBox={this.props.showLogin}
              isElectionPoll
              isExternalClass={s.Electionpollwidget}
            />
          );
        }
      }
    }
    return returnHtml;
  };

  // getGamesData = () => (
  //   <ElementInView
  //     gaCategory="gameswidget_spas"
  //     gaLabel="web"
  //     gaAction="view_widget"
  //   >
  //     <LoadableComponentLoader
  //       loadOnScroll
  //       loadableComponentName="DailyPuzzles"
  //       fallbackComponent={<TitleBoxSkeleton />}
  //       gamesToShow={['crossword', 'sudoku', 'word-search']}
  //       title="PLAY EXCITING PUZZLES & GAMES"
  //       gaMetaData={{ EC: 'gameswidget_spas' }}
  //       iconImageIdMap={{
  //         cw: 88709998,
  //         sudoku: 88710081,
  //         ws: 88710085,
  //         wf: 88710095,
  //       }}
  //       isWidget
  //       gamesEntryWidget
  //       gamesEntryWidgetAS
  //     />
  //   </ElementInView>
  // );

  // getAsBriefs = () => {
  //   // const articleshowData = this.props.articleData;
  //   // const { widgets } = articleshowData;
  //   if (this.props.blocked !== -1) {
  //     return null;
  //   }
  //   const subsec2 = _get(
  //     this.props.articleData.navsubsecs,
  //     'subsec2',
  //     undefined,
  //   );
  //   if (
  //     subsec2 &&
  //     typeof subsec2 === 'object' &&
  //     typeof subsec2.subsecmsid2 !== 'undefined' &&
  //     subsec2.subsecmsid2 === '82453999'
  //   ) {
  //     // Removing news in briefs if article is from crypto currenmcy
  //     return null;
  //   }
  //   let returnHtml = null;
  //   const sectionName =
  //     this.props.articleData.navsubsecs &&
  //     this.props.articleData.navsubsecs.subsec1 &&
  //     this.props.articleData.navsubsecs.subsec1.subsecname1
  //       ? this.props.articleData.navsubsecs.subsec1.subsecname1
  //       : '';

  //   let asBriefsData;
  //   if (this.props.asBriefsData) {
  //     if (this.props.isUserPrime && this.props.asBriefsData.items) {
  //       // remove ad first.
  //       asBriefsData = this.props.asBriefsData.items.filter(
  //         item => typeof item.adCode === 'undefined',
  //       );
  //       this.props.asBriefsData.items = asBriefsData;
  //     }
  //   }
  //   returnHtml = this.props.asBriefsData && (
  //     <div className={`${s.briefssticky} briefscontainer`}>
  //       <ElementInView gaLabel="Briefs_view">
  //         <ArticleshowBriefs
  //           asSectionName={sectionName}
  //           asBriefsData={this.props.asBriefsData}
  //           isWapView={this.props.isWapView}
  //           isUserPrime
  //           gaCategory={this.props.categoryForGA}
  //           gaAction="click"
  //           gaLabel="Briefs_"
  //         />
  //       </ElementInView>
  //     </div>
  //   );
  //   return returnHtml;
  // };
  renderOldStoryMsg = oldStoryText => {
    const msg = typeof oldStoryText === 'string' ? oldStoryText.trim() : '';

    return msg.length ? oldStoryText : '';
  };

  goToArticle = (e, msid, index) => {
    e.preventDefault();
    // if (!dataPresent || msid === this.props.activeMsid) {
    //   return;
    // }
    const elem = document.querySelector(`[data-articlemsid="${msid}"]`);
    const categoryForGA =
      typeof window !== 'undefined' && window.categoryForSearchGA
        ? window.categoryForSearchGA
        : '';
    //const { isSticky } = this.state;
    if (elem) {
      sendGaThroughProps({
        data: {
          //gaCategory: `LHS${isSticky ? '_sticky' : ''}_${index}`,
          gaCategory: `${categoryForGA}`,
          gaAction: 'Widget-Up_Next_V1-Click',
        },
      });
      const elemTop = elem.getBoundingClientRect();
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      const top = elemTop.top + scrollTop;
      smoothScroll(top - 50, 3000, () =>
        this.props.changeActiveArticle(msid, index),
      );
    }
  };
  // getReadAlsoWidget = () => {
  //   const { widgets, id } = this.props.articleData;
  //   let myComp = null;
  //   if (widgets && Array.isArray(widgets)) {
  //     for (let i = 0; i < widgets.length; i += 1) {
  //       if (
  //         typeof widgets[i] !== 'undefined' &&
  //         typeof widgets[i].id !== 'undefined' &&
  //         widgets[i].id === 'related_stories_widt'
  //       ) {
  //         myComp = (
  //           <ReadAlsoBootomWidget
  //             widgetData={widgets[i]}
  //             widgetClass="desktop"
  //             artmsid={id}
  //           />
  //         );
  //         break;
  //       }
  //     }
  //   }
  //   return myComp;
  // };
  getVisualStories = () => {
    const articleshowData = this.props.articleData;
    if (
      articleshowData &&
      articleshowData.visualStories &&
      Array.isArray(articleshowData.visualStories.items) &&
      articleshowData.visualStories.items.length
    ) {
      this.isVisualStoryRendered = true;
      return (
        <ElementInView
        // gaAction={
        //   this.props.isEtimesArticle
        //     ? 'view-visual-stories'
        //     : 'scroll_measure'
        // }
        // gaLabel={
        //   this.props.isEtimesArticle
        //     ? subSecSeoLocation
        //     : 'visualstories_view'
        // }
        >
          <div className="visualstoriesas_wrapper">
            <WithVisualStories
              sectionData={{
                name: articleshowData.visualStories.title,
                items: articleshowData.visualStories.items,
                ga4Type: 'Visual Story GA',
              }}
              cardWrapperClass="visualstoriesas"
              clickGaAction={
                this.props.isEtimesArticle
                  ? 'click-visual-stories'
                  : 'click_visualstory'
              }
              gaLabelConnector={this.props.isEtimesArticle ? '-' : ''}
              isEtimesArticle={this.props.isEtimesArticle}
              disableIsLarge
            />
          </div>
        </ElementInView>
      );
    }
    return null;
  };

  isValidToShowInBetweenContent = () => {
    const articleshowData = this.props.articleData;
    const { ag: articleAgencyName } = articleshowData;
    return (
      !this.props.isMspArticle &&
      articleAgencyName !== 'Mediawire' &&
      articleAgencyName !== 'SPOTLIGHT' &&
      articleAgencyName !== 'Brandwire'
    );
  };
  isThisArticleAdActive = () =>
    !this.props.isUserPrime && this.isValidToShowInBetweenContent();

  isValidToShowAffiliateWidget = () => this.isValidToShowInBetweenContent();

  AffiliateRHSWidget = () => {
    const articleshowData = this.props.articleData;
    const { isMspArticle } = this.props;
    const {
      ag: articleAgencyName,
      affKeyword,
      navsubsecs: {
        subsec1: { subsecnameseo1 } = {},
        subsec2: { subsecnameseo2 } = {},
      } = {},
    } = articleshowData;

    const isCryptoCurrencyArticle =
      _get(articleshowData, 'navsubsecs.subsec2.subsecmsid2') === '82453999';
    const renderCondition =
      !isMspArticle &&
      !this.isAffilateWidgetRendered &&
      articleAgencyName !== 'Mediawire' &&
      articleAgencyName !== 'SPOTLIGHT' &&
      articleAgencyName !== 'Brandwire' &&
      !isCryptoCurrencyArticle;

    if (renderCondition) {
      this.isAffilateWidgetRendered = true;
    }

    return (
      <div id="affiliate_non_msp_rhs_widget">
        {renderCondition && (
          <AffiliatesContentV2
            enableWidgetsOnLoad
            type="toi_widget_slots"
            client="affiliates"
            filters={{
              pagename: 'articleshow',
              keyword: affKeyword,
              sectionl1: subsecnameseo1,
              sectionl2: subsecnameseo2,
            }}
            componentProps={{
              config: {
                // affiliateName,
                ga4: {
                  section: subsecnameseo1,
                  subsection: subsecnameseo2,
                },
              },
            }}
          />
        )}
      </div>
    );
  };

  showSocialShareWidget = () => {
    this.setState({ showSocialWidget: true });
    analyticsWrapper('ga4', {
      event: 'user_click',
      type: 'social_share',
      category: 'articleshow_sticky',
    });
  };

  hideSocialShareWidget = () => {
    this.setState({ showSocialWidget: false });
  };

  getAffiliateWidgetCarousel = () => {
    const {
      story: articleStory = [],
      navsubsecs: { subsec3: { subsecnameseo3 } = {} } = {},
    } = this.props.articleData;

    const affWidgetCarouselData = articleStory.find(
      (item = {}) => item.tn === 'affiliates_product_carousel',
    );
    const { type, affiliateName, sectionl1, productid, shouldRender } =
      affWidgetCarouselData || {};
    const windowFunctions = [];
    if (sectionl1 && type !== 'hp_bulleted_carousel') {
      windowFunctions.push(
        getOnClickWindowFuntion('dfpPush', [
          'ua:click',
          `${affiliateName || 'amazon'}-affiliate-${sectionl1}`,
        ]),
      );
    }

    return (
      shouldRender && (
        <div>
          <AffiliatesContent
            enableWidgetsOnLoad
            type={`${type}${this.props.isMspUSPage ? '_us' : ''}`}
            inViewClass="aff_sticky_widget"
            minHeight="400px"
            handlePaidTraffic
            handleOrganic
            affiliateCountry={this.props.isMspUSPage ? 'us' : ''}
            componentProps={{
              config: {
                useGA4: true,
                affiliateName: 'amazon',
                ga4: {
                  type: 'affiliate_widget',
                  category: 'carousel',
                  story_no: '',
                  subsection: sectionl1,
                  subsection2: subsecnameseo3,
                  windowFunctions,
                },
              },
            }}
            filters={{
              pagename: 'articleshow',
              affiliateName,
              sectionl1,
              productid,
              keyword: getKeyword(),
              section: subsecnameseo3,
            }}
          />
        </div>
      )
    );
  };

  aboutAuthorWidget = () => {
    const {
      getAuthorWidgetDetails: {
        description,
        facebook: fb,
        twitter,
        image,
      } = {},
    } =
      this.props.articleData || {};
    let authorComponent = null;
    if (description) {
      // eslint-disable-next-line no-unused-vars
      const url = {
        fb,
        twitter,
      };
      const imgSrc = image
        ? `${TOI_DOMAIN}authorphoto/${image}.cms`
        : 'https://static.toiimg.com/photo/63379366.cms';
      authorComponent = (
        <div className={s.about_author} id="auhtor_widget">
          <div className={s.author_details}>
            <div className={s.author_imge}>
              <Image url={imgSrc} title="author" styleObj={s} noWidth />
            </div>
            <div className={s.author_social}>
              <div className={s.author}>
                <h5>About the Author</h5>
                <Links
                  to={
                    this.props?.articleData?.getAuthorWidgetDetails
                      ?.authorPageLink
                  }
                  className={s.author_name}
                >
                  {this.props?.articleData?.getAuthorWidgetDetails?.name}
                </Links>
              </div>
            </div>
          </div>
          <div
            id="author_desc"
            className={`${s.author_desc} ${
              !this.state.isReadMore ? s.readmorelineclamping : ''
            } `}
          >
            <p>
              {this.props?.articleData?.getAuthorWidgetDetails?.description}
              {this.props?.articleData?.getAuthorWidgetDetails?.description
                ?.length > 180 && (
                <button
                  className={s.readmore}
                  onClick={() => {
                    const divContentElem = document.getElementById(
                      'auhtor_widget',
                    );
                    this.setState(
                      { isReadMore: !this.state.isReadMore },
                      () => {
                        if (divContentElem && !this.state.isReadMore) {
                          divContentElem.scrollIntoView({
                            block: 'center',
                            behavior: 'smooth',
                          });
                        }
                      },
                    );
                    if (divContentElem && !this.state.isReadMore) {
                      divContentElem.classList.add(s.openauthor);
                    } else {
                      const divAuthorElem = document.getElementById(
                        'author_desc',
                      );
                      if (divContentElem && divAuthorElem) {
                        divAuthorElem.scrollTop = 0;
                        divContentElem.classList.remove(s.openauthor);
                      }
                    }
                  }}
                >
                  {!this.state.isReadMore ? `Read More` : `Show Less`}
                </button>
              )}
            </p>
          </div>
        </div>
      );
    }
    return authorComponent;
  };

  getBottomBanner = (story = []) => {
    const bannerData = story.find((item = {}) => item.tn === 'bottomBanner');
    if (bannerData) {
      const {
        href,
        dataURL,
        ga: { action = '', label = '' } = {},
        imgSrc,
        dataPlugin,
      } = bannerData;
      return (
        <ElementInView
          className={s.msp_banner}
          gaAction={action.replace('Click', 'View')}
        >
          <Links
            target="_blank"
            href={href}
            data-plugin={dataPlugin}
            rel="nofollow sponsored noreferrer"
            data-url={dataURL}
            onClick={() => {
              sendGaThroughProps({
                data: {
                  gaCategory: this.props.categoryForGA,
                  gaAction: action,
                  gaLabel: label,
                },
              });
            }}
          >
            <Image
              noWidth
              url={imgSrc}
              title="msp affiliate banner"
              styleObj={s}
            />
          </Links>
        </ElementInView>
      );
    }
    return '';
  };

  getAstroTalkRHSWidget = () => {
    const isAstrologyArticle =
      _get(this.props.articleData, 'navsubsecs.subsec1.subsecmsid1') ===
      '65857041';
    const isReligionArticle =
      _get(this.props.articleData, 'navsubsecs.subsec1.subsecmsid1') ===
      '79795437';
    const sectionl1 = _get(
      this.props.articleData,
      'navsubsecs.subsec1.subsecnameseo1',
    );
    const renderCondition =
      (isAstrologyArticle || isReligionArticle) && getGeoCountry() === 'IN';

    return (
      <div id="astro_talk_banner">
        {renderCondition && (
          <AffiliatesContentV2
            type="toi_widget_slots"
            client="affiliates"
            filters={{
              pagename: 'articleshow',
              slot: 'body_insert',
              sectionl1,
              keywords: 'astro_talk',
            }}
            componentProps={{
              config: {
                ga: {
                  label: this.props.msid,
                },
              },
            }}
          />
        )}
      </div>
    );
  };
  getOpenMindAstroRHSWidget = () => {
    const isAstrologyArticle =
      _get(this.props.articleData, 'navsubsecs.subsec1.subsecmsid1') ===
      '65857041';
    const isReligionArticle =
      _get(this.props.articleData, 'navsubsecs.subsec1.subsecmsid1') ===
      '79795437';
    const sectionl1 = _get(
      this.props.articleData,
      'navsubsecs.subsec1.subsecnameseo1',
    );
    const renderCondition =
      (isAstrologyArticle || isReligionArticle) && getGeoCountry() === 'IN';

    return (
      <div id="openMind_astro_banner">
        {renderCondition && (
          <AffiliatesContentV2
            type="toi_widget_slots"
            client="affiliates"
            filters={{
              pagename: 'articleshow',
              slot: 'rhs',
              sectionl1,
              keywords: 'open_mind_astro',
            }}
            componentProps={{
              config: {
                ga: {
                  label: this.props.msid,
                },
              },
            }}
          />
        )}
      </div>
    );
  };

  getAsrtoTalkNudge = () => {
    const articleshowData = this.props.articleData;
    const isAstrologyArticle =
      _get(articleshowData, 'navsubsecs.subsec1.subsecmsid1') === '65857041';
    const isReligionArticle =
      _get(articleshowData, 'navsubsecs.subsec1.subsecmsid1') === '79795437';
    const sectionl1 = _get(
      articleshowData,
      'navsubsecs.subsec1.subsecnameseo1',
    );
    let isAdCubeActive = false;
    if (typeof window !== 'undefined') {
      const { checkJarvisIsAdActive, adsconfig = {} } = window || {};
      if (typeof checkJarvisIsAdActive === 'function') {
        if (checkJarvisIsAdActive(adsconfig.cube) === 1) {
          isAdCubeActive = true;
        }
      }
    }

    return (
      getGeoCountry() === 'IN' &&
      (isReligionArticle || isAstrologyArticle) &&
      !isAdCubeActive && (
        <AffiliatesContentV2
          type="toi_widget_slots"
          client="affiliates"
          filters={{
            pagename: 'articleshow',
            slot: 'nudge',
            sectionl1,
          }}
          loadingComponent={<></>}
          componentProps={{
            immediateLoad: true,
          }}
        />
      )
    );
  };

  render() {
    this.brCount = 0;
    this.totalBrCount = 0;
    this.cardComponent1Rendered = false;
    this.cardComponent2Rendered = false;
    this.isAffilateWidgetRendered = false;
    const commentModerationVal = this.getCommentModerationData();
    const articleshowData = this.props.articleData;
    const isHotPicks =
      _get(articleshowData, 'navsubsecs.subsec1.subsecmsid1') === '106630271';

    // const ImageElement = ImageV2;
    const {
      msid,
      electionFlag,
      categoryForGA,
      // clientSideJpodCard,
      // subSecSeo2Location,
      parentMsid,
      hasFixedHeading,
      isMspArticle,
      // exitIntentPopup,
      isCardCMS,
      breadCrumbData,
      breadCrumbTitle,
      sectionName,
      perpetual,
      sidebarData,
      isSPOTLIGHTArticle,
      isReviewsPage,
    } = this.props;
    const exitIntentPopup = '';
    const skipPersonalizationWidget = !this.props.isUserLoggedin;
    // const isAstrologyArticle =
    //   _get(articleshowData, 'navsubsecs.subsec1.subsecmsid1') === '65857041';
    // const isReligionArticle =
    //   _get(articleshowData, 'navsubsecs.subsec1.subsecmsid1') === '79795437';
    // const lhsAstroNudgeClassName = isAstrologyArticle || isReligionArticle ? s.abc : '';
    const trendingTopicLinkslist = sidebarData?.data?.filter(
      data => data.tn === 'searchwidget',
    );

    const trendingBottomWidgetLinks = {
      items: articleshowData?.trendingBottomWidgetLinks?.items,
      name: articleshowData?.trendingBottomWidgetLinks?.widgetTitle,
      ga4Type: articleshowData?.trendingBottomWidgetLinks?.ga4Type,
    };

    const subsecname3 = _get(articleshowData, 'navsubsecs.subsec3.subsecname3');
    const subsecname4 = _get(articleshowData, 'navsubsecs.subsec4.subsecname4');

    const mspSectionName = `${subsecname3 || ''}${
      subsecname4 ? `_${subsecname4}` : ''
    }`;
    const isParent = articleshowData.id === parentMsid;
    const showFixedHeading = !isParent && hasFixedHeading;
    // const showFixedHeading = false;
    const { showBackToText } = this.state;
    const removeLHSandRHS =
      _get(articleshowData, `metaInfo.SpecialID`) === 'removerhs';
    const { story, ads } = articleshowData;
    const mspBottomBanner = isMspArticle && this.getBottomBanner(story);
    const { ctn } = ads || {};
    //#TODO: improve logic for articleshow mini
    const isArticleMini = this.props.isMiniView && !this.state.showFullArticle;
    const toggleMiniClass = isArticleMini ? s.miniclamp : '';
    const isMgidCountry =
      typeof window !== 'undefined' && window.Times?.ismgidCountry;
    const isThisArticleAdActive = this.isThisArticleAdActive();
    const breadCrumbString =
      this.props.articleData.bc instanceof Array
        ? this.props.articleData.bc
            .map(
              item =>
                typeof item.value === 'string'
                  ? item.value.toLowerCase().replace(' ', '_')
                  : '',
            )
            .join('_')
        : '';
    this.id = articleshowData.id;
    const frmapp = this.props.isAppView;
    let leadImageHtml;
    let topCommentWithAdComp;

    const isWillowMetaPresent =
      _get(articleshowData, `metaInfo.SpecialID`, '') === 'willow';

    const isExplainerArticle =
      _get(articleshowData, `metaInfo.NatureOfContent`, '').toLowerCase() ===
      'explainer';

    const isSynopsisEnabled = articleshowData.ag !== 'SPOTLIGHT';

    const isSynopsisPresent =
      articleshowData.syn && articleshowData.syn.length > 0;

    const isHighlighPresent =
      (articleshowData.hlts && articleshowData.hlts.length > 0) ||
      (articleshowData.hltsCdata && articleshowData.hltsCdata.length > 0);

    // AF-526
    const keyword100 = _get(articleshowData, 'seo.keyword100');
    const firstKeyword =
      _get(articleshowData, 'seo.keywords', '').split(',')[0] || undefined;
    const imageAlt = isMspArticle ? keyword100 || firstKeyword : undefined;
    const qnaLayout =
      _get(articleshowData, `metaInfo.ToneOfContent`, '').toLowerCase() ===
      'qna';
    if (
      this.props.blocked === -1 &&
      articleshowData.videos &&
      articleshowData.videos.length > 0
    ) {
      leadImageHtml = (
        <>
          <LeadImageOrVideo
            hl={articleshowData.hl}
            artilceMsid={articleshowData.id}
            video={articleshowData.videos[0]}
            videoImageId={
              articleshowData.imageid && articleshowData.imageid.length
                ? articleshowData.imageid.split('&')[0]
                : ''
            }
            highlight={articleshowData.hlts}
            highlightCdata={articleshowData.hltsCdata}
            styleObj={s}
            isWapView={this.props.isWapView}
            isUserPrime={this.props.isUserPrime}
            videoCaption={
              articleshowData.images && articleshowData.images[0]
                ? articleshowData.images[0].cap
                : ''
            }
            loadVideoTheatreSlider={this.props.loadVideoTheatreSlider}
            videoTheatreSliderData={this.props.videoTheatreSliderData}
            addNextVideoMsid={this.props.addNextVideoMsid}
            widgets={this.props.articleData.widgets}
            isArticleshow
            cb={this.props.stickyAppCb}
            bottom={650}
            isExplainerArticle={isExplainerArticle}
            isEtimesArticle={this.props.isEtimesArticle}
            loadedMiniTvComponent={this.props.loadedMiniTvComponent}
            showMiniTvPlayer={this.props.showMiniTvPlayer}
            isPerpetual={perpetual}
            activeMsid={this.props.activeMsid}
            isSPOTLIGHTArticle={isSPOTLIGHTArticle}
            isAutoPublishedArticle={this.props.isAutoPublishedArticle}
          />
        </>
      );
    } else if (articleshowData.images && articleshowData.images.length === 1) {
      leadImageHtml = (
        <>
          <LeadImageOrVideo
            hl={articleshowData.hl}
            image={articleshowData.images[0]}
            imageAlt={imageAlt}
            highlight={articleshowData.hlts}
            isWapView={this.props.isWapView}
            highlightCdata={articleshowData.hltsCdata}
            isUserPrime={this.props.isUserPrime}
            styleObj={s}
            widgets={this.props.articleData.widgets}
            isArticleshow
            className={
              this.isUnavailableArticle()
                ? getInactiveArticleClass({
                    reason: articleshowData.reason,
                  })
                : ''
            }
            cb={this.props.stickyAppCb}
            bottom={650}
            isExplainerArticle={isExplainerArticle}
            isMspArticle={isMspArticle}
            syn={isMspArticle ? '' : articleshowData.syn}
            activeMsid={this.props.activeMsid}
            isSPOTLIGHTArticle={isSPOTLIGHTArticle}
            isAutoPublishedArticle={this.props.isAutoPublishedArticle}
          />
        </>
      );
    } else if (articleshowData.images && articleshowData.images.length > 1) {
      const { images } = articleshowData;
      leadImageHtml = (
        <>
          <LeadImageOrVideo
            hl={articleshowData.hl}
            imgList={images}
            highlight={articleshowData.hlts}
            isWapView={this.props.isWapView}
            highlightCdata={articleshowData.hltsCdata}
            isUserPrime={this.props.isUserPrime}
            styleObj={s}
            widgets={this.props.articleData.widgets}
            isArticleshow
            className={
              this.isUnavailableArticle()
                ? getInactiveArticleClass({
                    reason: articleshowData.reason,
                  })
                : ''
            }
            cb={this.props.stickyAppCb}
            bottom={650}
            isExplainerArticle={isExplainerArticle}
            isMspArticle={isMspArticle}
            syn={articleshowData.syn}
            activeMsid={this.props.activeMsid}
            isSPOTLIGHTArticle={isSPOTLIGHTArticle}
            isAutoPublishedArticle={this.props.isAutoPublishedArticle}
          />
        </>
      );
    } else if (
      !articleshowData.images &&
      !(
        articleshowData.ag === 'Mediawire' || articleshowData.ag === 'Brandwire'
      )
    ) {
      leadImageHtml = (
        <>
          <LeadImageOrVideo
            hl={articleshowData.hl}
            image={{
              imagesize: 110164,
              id: 47529300,
              imageid: '47529300&imgsize=19456',
            }}
            imageAlt={imageAlt}
            highlight={articleshowData.hlts}
            isWapView={this.props.isWapView}
            highlightCdata={articleshowData.hltsCdata}
            isUserPrime={this.props.isUserPrime}
            styleObj={s}
            widgets={this.props.articleData.widgets}
            isArticleshow
            className={
              this.isUnavailableArticle()
                ? getInactiveArticleClass({
                    reason: articleshowData.reason,
                  })
                : ''
            }
            cb={this.props.stickyAppCb}
            bottom={650}
            isExplainerArticle={isExplainerArticle}
            isMspArticle={isMspArticle}
            syn={isMspArticle ? '' : articleshowData.syn}
            activeMsid={this.props.activeMsid}
            isSPOTLIGHTArticle={isSPOTLIGHTArticle}
            isAutoPublishedArticle={this.props.isAutoPublishedArticle}
          />
        </>
      );
    }
    let subSecSeoLocation =
      _get(this.props.articleData, 'navsubsecs.subsec1.seolocation1') || '';

    const subsecmsid2 =
      _get(this.props.articleData, 'navsubsecs.subsec2.subsecmsid2') || '';
    if (
      this.props.isEtimesArticle &&
      subsecmsid2 &&
      subsecmsid2 === this.etimesFoodSectionMsid
    ) {
      subSecSeoLocation = 'food';
    }

    if (story && story.length > 0) {
      story.forEach(item => {
        if (item.tn === 'br') {
          this.totalBrCount += 1;
        }
      });
    }
    return (
      <>
        {/* {this.props.parentMsid !== this.props.msid &&
          story &&
          story.length > 0 && (
            <div className={`${s.separator} clearfix`}>
              <i />
              <span>Up Next</span>
            </div>
          )} */}
        {articleshowData &&
          _get(articleshowData, `ads.ctn.slots.NativePPD`) && (
            <AdCaller
              pauseAdCall={this.props.blocked !== -1}
              //className={s.desktop_ads}
              data={{
                adCode: _get(ctn, 'slots.NativePPD.slotId'),
                msid,
              }}
              isCTN
            />
          )
        // adsCampaignStatus &&
        // _get(adsCampaignStatus, 'PPD.status') === 1 && (
        //   <AdCaller
        //     lazyload
        //     data={{
        //       ..._get(articleshowData, `ads.dfp.slots.PPD`, {}),
        //       geo: _get(adsCampaignStatus, 'PPD.geo', ''),
        //       divId: `${
        //         _get(articleshowData, `ads.dfp.slots.PPD`, {}).divId
        //       }-${msid}`,
        //       targetingInfo: {
        //         ..._get(articleshowData, `ads.dfp.info`, {}),
        //       },
        //     }}
        //   />
        // )
        }
        {/* Starts- Articleshow Main Body Wrapper */}
        {/* Do not add fixed elements */}
        <div
          className={`${s.main_ASwrapper} ${
            removeLHSandRHS ? s.removelhsrhs : ''
          } `}
          data-translate-id="cw"
          data-translate-page="1"
          ref={this.articleshowRef}
          data-font={this.props.textSize}
          data-mspSectionName={mspSectionName}
          data-articlemsid={this.props.msid}
        >
          {/* Top searches to be replaced with new component */}

          {this.props.parentMsid !== this.props.msid &&
            story &&
            story.length > 0 && (
              <div className={`${s.separator} clearfix`}>
                <i />
                <span>Up Next</span>
              </div>
            )}
          {!this.props.isUserPrime && this.atfAdCode()}
          <div
            className={`${s.innerBody} innerbody ${
              perpetual ? s.perpetualAS : ''
            }`}
          >
            <div
              className={cn({
                [s.full_width]: isReviewsPage,
                [s.left]: true,
                [s.removelhsrhs]: removeLHSandRHS,
              })}
            >
              {!isCardCMS && (
                <BreadCrumb
                  data={breadCrumbData}
                  title={breadCrumbTitle}
                  wrapperClass="breadcrumb"
                  showHomeIcon
                />
              )}
              {!isCardCMS &&
                this.props.topSearches &&
                Array.isArray(this.props.topSearches.items) &&
                this.props.topSearches.items.length && (
                  <TrendingSlider
                    topSearches={this.props.topSearches.items}
                    title={this.props.topSearches?.name}
                  />
                )}
              <div className={s.articleHead_top}>
                {showBackToText &&
                  articleshowData &&
                  articleshowData.advertorial &&
                  articleshowData.advertorial.backToAgencyText &&
                  articleshowData.advertorial.sponsoredUrl && (
                    <div className={s.backto_brandwire}>
                      <BackToBrandwire
                        sponsoredUrl={articleshowData.advertorial.sponsoredUrl}
                        agency={articleshowData.ag}
                        backToAgencyText={
                          articleshowData.advertorial.backToAgencyText
                        }
                      />
                    </div>
                  )}
                {/* Toggle fixedHeading class and add dynamic margin top accoring to story length. I didn't add next story seprator  */}
                {this.props.enableNextArticleStickyPopUp && (
                  <div
                    className={`${s.next_head} ${
                      showFixedHeading ? s.fixedHeading : ''
                    }`}
                    onClick={e =>
                      this.goToArticle(
                        e,
                        articleshowData.id,
                        this.props.articleIndex,
                        articleshowData.wu,
                      )
                    }
                  >
                    {this.props.parentMsid !== this.props.msid &&
                      story &&
                      story.length > 0 && (
                        <div className={`${s.separator} clearfix`}>
                          <i />
                          <span>Up Next</span>
                        </div>
                      )}
                    <div className={`${s.upnextHeading}`}>
                      <span
                        dangerouslySetInnerHTML={{ __html: articleshowData.hl }}
                      />
                    </div>
                  </div>
                )}

                {articleshowData.oldStoryText &&
                  !isMspArticle && (
                    <div className={s.oldarticle_tag}>
                      {this.renderOldStoryMsg(articleshowData.oldStoryText)}
                    </div>
                  )}
                <InViewObserver
                  inViewCallback={() => {
                    analyticsWrapper('ga4', {
                      event: 'user_scroll',
                      type: `scroll-depth`,
                      category: 'articleshow_scroll',
                      label: 'article_title',
                    });
                  }}
                  viewMargin="100px 0px 100px 0px"
                >
                  <h1
                    className={`${s.articleHeading}`}
                    data-ua-type="1"
                    data-sp-pd-click="stpPgtnAndPrvntDefault(event)"
                    onClick={event => {
                      window.stpPgtnAndPrvntDefault(event);
                    }}
                  >
                    <span
                      dangerouslySetInnerHTML={{ __html: articleshowData.hl }}
                    />
                    {articleshowData.icon &&
                    articleshowData.icon === 'smiley' ? (
                      <img
                        className={s.humour_emoji}
                        src="https://static.toiimg.com/photo/50686029.cms"
                        alt="Smiley"
                      />
                    ) : null}
                  </h1>
                </InViewObserver>
                {articleshowData.ag === 'Brandwire' &&
                articleshowData.advertorial &&
                articleshowData.advertorial.sponsoredText ? (
                  <div className={s.brandwire_sponsored_txt}>
                    {articleshowData.advertorial.sponsoredText}
                  </div>
                ) : null}
                <div className={`${s.byline_action} byline_action`}>
                  <Byline
                    ag={articleshowData.ag || ''}
                    guestName={articleshowData.guestName || ''}
                    dl={articleshowData.dl || ''}
                    dlStr={articleshowData.dlStr || ''}
                    updStr={articleshowData.updStr || ''}
                    upd={articleshowData.upd}
                    author={articleshowData.authors}
                    isWapView={this.props.isWapView}
                    sClassName="byline"
                    removeTime={this.props.isMspUSPage}
                    navSubsection={
                      this.props.articleData.navsubsecs &&
                      this.props.articleData.navsubsecs.subsec2
                    }
                  />

                  <div
                    className={`${s.articleAction_wrapper}`}
                    data-socialshare={articleshowData.id}
                  >
                    <div className={s.left}>
                      {!this.isUnavailableArticle() && (
                        <React.Fragment>
                          {/* {!isMspArticle && (
                          <SocialWidget
                            msid={articleshowData.id}
                            isParent={
                              articleshowData.id === this.props.parentMsid
                            }
                            url={articleshowData.su || articleshowData.wu}
                            title={articleshowData.hl}
                            isWapView={false}
                            isSmallicon
                            image={
                              articleshowData.images
                                ? articleshowData.images[0]
                                : undefined
                            }
                            openSidebar={this.openSidebar}
                            commentsCount={
                              this.props.blocked === -1
                                ? this.props.commentsCount
                                : 0
                            }
                            // commentsCount={this.props.commentsCount}
                            wu={articleshowData.wu}
                            via={articleshowData.via}
                            isTablet={this.props.isTablet}
                            commentModeration={commentModerationVal}
                            type="ATF"
                            gaCategory={categoryForGA}
                            gaAction="click"
                            gaIndex="atfShare_"
                            textRequired={false}
                            tpShow
                            linkeDin
                          />
                        )} */}

                          <div
                            className={`${s.inneraction} ${
                              isMspArticle ? s.shift_left : ''
                            }`}
                          >
                            {/* <div
                              data-socialshare={articleshowData.id}
                              ref={this.timespointRef}
                              className="tp_widget_as"
                            >
                              <TimesPointHeaderWidget
                                msid={articleshowData.id}
                                title={articleshowData.hl}
                                url={articleshowData.su || articleshowData.wu}
                                wu={articleshowData.wu}
                                isParent
                                via={articleshowData.via}
                                textRequired={false}
                                tpShow
                                linkeDin
                                isWapView={false}
                                gaCategory={categoryForGA}
                                gaAction="click"
                                gaIndex="atfShare_"
                                isSmallicon
                                isPerpetual={perpetual}
                                articleIndex={
                                  perpetual ? this.props.articleIndex : null
                                }
                              />
                            </div> */}

                            <div
                              className={`${s.timelineshare} icon_share_wrap`}
                              // onClick={isWapView && socialWidgetToggle}
                              onMouseEnter={this.showSocialShareWidget}
                              onMouseLeave={this.hideSocialShareWidget}
                            >
                              <div className={`${s.icon_share}`}>
                                <i
                                  className={`${s.shareicon} ${
                                    this.state.showSocialWidget ? s.active : ''
                                  }`}
                                />
                                <span>Share</span>
                              </div>

                              {this.state.showSocialWidget && (
                                <LoadableComponentLoader
                                  loadOnScroll
                                  loadableComponentName="SocialSharingWeb"
                                  msid={articleshowData.id}
                                  isParent={
                                    articleshowData.id === this.props.parentMsid
                                  }
                                  url={articleshowData.su || articleshowData.wu}
                                  title={articleshowData.hl}
                                  className={s.icon_hover_social}
                                  isWapView={false}
                                  isSmallicon
                                  image={
                                    articleshowData.images
                                      ? articleshowData.images[0]
                                      : undefined
                                  }
                                  openSidebar={this.openSidebar}
                                  commentsCount={
                                    this.props.blocked === -1
                                      ? this.props.commentsCount
                                      : 0
                                  }
                                  // commentsCount={this.props.commentsCount}
                                  wu={articleshowData.wu}
                                  via={articleshowData.via}
                                  isTablet={this.props.isTablet}
                                  commentModeration={commentModerationVal}
                                  type="ATF"
                                  gaCategory={categoryForGA}
                                  gaAction="click"
                                  gaIndex="atfShare_"
                                  textRequired={false}
                                  linkeDin
                                  sectionName={sectionName.toLowerCase()}
                                />
                              )}
                            </div>

                            {articleshowData.readInOthLang && (
                              <ReadInOtherLanguage
                                langData={articleshowData.readInOthLang}
                                gaCategory="ATF_share_bar"
                              />
                            )}

                            <EmailPrintFontOptions
                              msid={articleshowData.id}
                              url={articleshowData.su}
                              title={articleshowData.hl}
                              changeSize={this.props.onSizeChange}
                              textSize={this.props.textSize}
                              showFontAlterOptions={
                                this.props.showFontAlterOptions
                              }
                              gaCategory={categoryForGA}
                              gaAction="click"
                              gaLabel="atf"
                            />
                          </div>
                          {/* <div className={`${s.icon_share}`}>
                            <i
                              className={`${s.shareicon} ${
                                this.state.showSocialWidget ? s.active : ''
                              }`}
                            />
                            <span>Follow us </span>
                          </div> */}
                          <div className={`${s.gnews} ${s.gnews_top}`}>
                            <Links
                              href={
                                this.props.isEtimesArticle
                                  ? 'https://news.google.com/publications/CAAqBwgKMKrsugswt4fSAw'
                                  : 'https://news.google.com/publications/CAAqBwgKMM6y_Qowwu70Ag'
                              }
                              target="_blank"
                              rel="noopener noreferrer"
                              onClick={() => {
                                sendGaThroughProps({
                                  data: {
                                    gaCategory: this.props.categoryForGA,
                                    gaAction: 'user_click',
                                    gaLabel: 'google_news',
                                  },
                                });
                                analyticsWrapper('ga4', {
                                  event: 'user_click',
                                  type: 'follow_google_news',
                                  category: 'articleshow_sticky',
                                });
                              }}
                            >
                              Follow us <i />
                            </Links>
                          </div>
                        </React.Fragment>
                      )}
                    </div>
                    {/* <div className={s.right} /> */}
                  </div>
                </div>
              </div>
              <div className="clearfix" />
              <div
                className={`${s.left_inner} ${
                  !isReviewsPage || !isMspArticle ? s.leadImageInlineView : ''
                }`}
              >
                {/* {!isMspArticle &&
                  !skipPersonalizationWidget && (
                    <div className={s.astro_left_section_sticky}>
                      <PersonaliseWidget
                        card="upNext"
                        section={this.getSectionName() || ''}
                        subsection={_get(
                          this.props.articleData?.navsubsecs?.subsec2,
                          'subsecname2',
                          '',
                        )}
                        msid={this.props.msid}
                        template="AS"
                        contentprimestatus="non-prime"
                        userprimestatus={
                          this.props.isUserPrime ? 'prime' : 'non-prime'
                        }
                        styleObj={{
                          minHeight: '550px',
                          position:
                            isReligionArticle || isAstrologyArticle
                              ? 'static'
                              : 'sticky',
                        }}
                        classname="upNextShimmer"
                        dataset={{ 'data-translate-sticky': 100 }}
                      />
                      <div id="astro_talk_nudge">
                        {this.getAsrtoTalkNudge()}
                      </div>
                    </div>
                  )} */}
                {isMspArticle &&
                  !removeLHSandRHS &&
                  this.props.nextStories &&
                  this.props.nextStories.length > 0 && (
                    <NextArticlesLHSv2
                      styleObj={s}
                      nextStories={this.props.nextStories}
                      changeActiveArticle={this.props.changeActiveArticle}
                      currentStory={this.props.parentStory}
                      activeMsid={this.props.msid}
                      articleShowData={this.props.allArticlesData}
                      sectionName={this.getSectionName()}
                      msid={articleshowData.id}
                      isValidToShowAffiliateWidget={this.isValidToShowAffiliateWidget()}
                      setSaleNudgeVisibilityFn={
                        this.props.setSaleNudgeVisibilityFn
                      }
                      isEtimesArticle={this.props.isEtimesArticle}
                    />
                  )}

                <div
                  className={`${s.articlebody}  ${
                    this.props.blocked === 1 ? s.article_blocked : ''
                  }`}
                >
                  <div className="heightCalc">
                    {isSynopsisPresent &&
                      isSynopsisEnabled && (
                        <div className="art_synopsis">
                          <Synopsis synopsis={articleshowData.syn} />
                        </div>
                      )}
                    <div
                      data-articlebody="1"
                      ref={myRef => {
                        this.articleBodyRef = myRef;
                      }}
                      className={`fewcent-${articleshowData.id}${
                        this.props.articleIndex === 0 ? ' js_tbl_article' : ''
                      }`}
                    >
                      {/* <div className={s.desktop_ads_inline}>
                    <AdCaller
                      pauseAdCall={this.props.blocked !== -1}
                      data={{
                        ..._get(articleshowData, `ads.dfp.slots.AS660`, {}),
                        divId: `${
                          _get(articleshowData, `ads.dfp.slots.AS660`, {}).divId
                        }-${msid}`,
                        targetingInfo: {
                          ..._get(articleshowData, `ads.dfp.info`, {}),
                        },
                      }}
                    />
                  </div> */}
                      {isMspArticle && (
                        <>
                          {leadImageHtml}
                          {articleshowData.ismt && (
                            <Mocktale {...articleshowData.advertorial} />
                          )}
                          {isHighlighPresent && (
                            <Keyhighlights
                              highlight={articleshowData.hlts}
                              highlightCdata={articleshowData.hltsCdata}
                            />
                          )}

                          <div id="affilaite_widget_carousel">
                            {isMspArticle &&
                              !isHotPicks &&
                              this.getAffiliateWidgetCarousel()}
                          </div>
                        </>
                      )}
                      <div
                        className={`${
                          s.article_content
                        } clearfix ${toggleMiniClass} ${
                          this.isUnavailableArticle()
                            ? s[
                                getInactiveArticleClass({
                                  reason: articleshowData.reason,
                                })
                              ]
                            : ''
                        }`}
                        onMouseUp={e => this.selectText(e)}
                      >
                        {!isMspArticle && (
                          <div className={s.leadImageInlineWrap}>
                            {leadImageHtml}
                          </div>
                        )}
                        {articleshowData.cbt ? (
                          <div
                            className={s.crossbrandingtext}
                            dangerouslySetInnerHTML={{
                              __html: unescape(articleshowData.cbt),
                            }}
                          />
                        ) : null}
                        {isMspArticle &&
                          !skipPersonalizationWidget &&
                          exitIntentPopup !== undefined &&
                          exitIntentPopup}
                        {qnaLayout && (
                          <>
                            {this.renderFactsheetLayout(story, articleshowData)}
                          </>
                        )}
                        {!qnaLayout &&
                          story &&
                          story.length &&
                          story.map((data, index) => (
                            <React.Fragment key={`${data.tn}_${index}`}>
                              {this.getComponents(
                                data,
                                index,
                                articleshowData,
                                true,
                              )}
                              {this.props.blocked === -1 &&
                                topCommentWithAdComp &&
                                topCommentWithAdComp.pos === index &&
                                topCommentWithAdComp.component}
                              {/* uncomment next line to add affiliate widget after 4th br */}
                              {/* {this.brCount === 4 &&
                                  this.totalBrCount >= 4 &&
                                  this.getAffilateWidget()} */}
                            </React.Fragment>
                          ))}
                        {/* {hindsightAdObj ? (
                      <AdCaller
                        className={s.hindsight}
                        data={hindsightAdObj}
                        deviceType="all"
                      />
                    ) : null} */}
                        {!(
                          articleshowData.ag === 'Mediawire' ||
                          articleshowData.ag === 'SPOTLIGHT' ||
                          articleshowData.ag === 'Brandwire' ||
                          isMspArticle
                        ) && (
                          <AdCaller
                            key={`mgid_bottom_${this.props.articleIndex}`}
                            skipReRender
                            msid={this.props.msid}
                            data={{
                              jname: 'mgid_bottom',
                              articleIndex: this.props.articleIndex,
                            }}
                          />
                        )}
                        {/* {isAstrologyArticle && (
                          <div className={s.moreInfo}>
                            <Links
                              target="_blank"
                              to="https://timesofindia.indiatimes.com/theopenmind-astroedition2023?utm_source=toi&utm_medium=astro_asbottomlink&utm_campaign=toi_astroevent"
                              doNotChangeURL
                            >
                              <span>
                                Learn about Astrology, Numerology and Tarot from
                                experts, sign up for The Open Mind Astro Summit
                                2023.
                              </span>
                            </Links>
                          </div>
                        )} */}
                        {/* {!isMspArticle && (
                          <div className="coronaaswidget">
                            {this.getReadNextWidget()}
                          </div>
                        )} */}

                        {this.state.showTwitterShareArticleContent && (
                          <div
                            className={s.shareInline}
                            onClick={() => this.shareSelectedText()}
                            style={{
                              top: `${this.state.shareOffsetTop}px`,
                              left: `${this.state.shareOffsetLeft}px`,
                            }}
                          >
                            <span
                              className={`${s.twitter} ${s.articlesprite} ${
                                s.ishare
                              }`}
                            >
                              <span className={s.inner}>Share to Twitter</span>
                            </span>
                          </div>
                        )}
                        {/* 
                        {articleshowData.videos &&
                          articleshowData.videos.length && (
                            <Links
                              to={articleshowData.videos[0].wu}
                              className={s.inline_vdolink}
                            >
                              <i>Watch</i>
                              <span> {articleshowData.videos[0].hl}</span>
                            </Links>
                          )} */}

                        {this.props.latestInfoGps ? (
                          <InfoGraphicMobile
                            nextLinks={this.props.latestInfoGps.slice(0, 4)}
                            theme="articleshowv2"
                          />
                        ) : null}
                        {this.props.isInfographicsArticle ? (
                          <span className={`${s.followshow}`}>
                            <a
                              rel="nofollow noreferrer noopener"
                              href="http://twitter.com/timesofindia"
                              target="_blank"
                            >
                              Follow us at @timesofindia
                            </a>{' '}
                            and{' '}
                            <a
                              rel="nofollow noreferrer noopener"
                              href="https://www.facebook.com/TimesofIndia"
                              target="_blank"
                            >
                              like us on Facebook
                            </a>
                          </span>
                        ) : null}
                      </div>
                      {this.props.blocked === 1 && (
                        <LoginAccount
                          onClick={this.props.handleBlockerScreenLogin}
                          gaAction="Nonprime-login_blocker|CTA"
                          gaLabel={`${this.getSectionName()}_${getWebUrl(
                            this.props.articleData.wu,
                          )}`}
                        />
                      )}
                      {/* Don't remove this | used by taboola Tier 1 geo | it should be on last */}
                      {this.props.articleIndex === 0 &&
                        isThisArticleAdActive && (
                          <div
                            className="js_tbl_readmore_btn"
                            key="js_tbl_readmore_btn"
                            // eslint-disable-next-line react/no-danger
                            dangerouslySetInnerHTML={{ __html: '' }}
                            suppressHydrationWarning
                            data-ua-type="1"
                            data-sp-click="stpPgtn(event)"
                            onClick={event => {
                              window.stpPgtn(event);
                            }}
                          />
                        )}
                    </div>
                    {/* {!(
                      ag === 'Mediawire' ||
                      ag === 'SPOTLIGHT' ||
                      ag === 'Brandwire' ||
                      isMspArticle
                    ) && <MidArticleSearch />} */}

                    {isWillowMetaPresent ? (
                      <WithGeo
                        render={({ geoCountry }) => {
                          const country =
                            typeof geoCountry === 'string'
                              ? geoCountry.toUpperCase()
                              : '';
                          if (country === 'US') {
                            //while making LIVE make this to US
                            return (
                              <div className={s.mobile_ads}>
                                <AdCaller
                                  pauseAdCall={this.props.blocked !== -1}
                                  data={{
                                    ..._get(
                                      articleshowData,
                                      `ads.dfp.slots.willowtv`,
                                      {},
                                    ),
                                    divId: `${
                                      _get(
                                        articleshowData,
                                        `ads.dfp.slots.willowtv`,
                                        {},
                                      ).divId
                                    }-${msid}`,
                                  }}
                                  lazyload={false}
                                  deviceType="all"
                                />
                              </div>
                            );
                          }
                          return null;
                        }}
                      />
                    ) : (
                      ''
                    )}
                    {isHotPicks && this.getAffiliateWidgetCarousel()}
                    {mspBottomBanner}
                    {subsecmsid2 &&
                      subsecmsid2 === '107935854' && (
                        <div className={s.timesbetter_banner}>
                          <Links
                            target="_blank"
                            to="https://stockgro.onelink.me/vNON/40gk5zl2"
                            data={{
                              gaCategory: 'StockgroBanner',
                              gaAction: 'click',
                              gaLabel:
                                this.props &&
                                this.props.articleData &&
                                this.props.articleData.wu,
                            }}
                          >
                            <img
                              src="https://static.toiimg.com/photo/109056209.cms"
                              alt=""
                            />
                          </Links>
                        </div>
                      )}
                    <div
                      className={`authorComment ${
                        this.props.articleIndex === 0
                          ? ' js_tblreadmore_hide'
                          : ''
                      }`}
                    >
                      {this.aboutAuthorWidget()}

                      {this.props.blocked === -1 &&
                        !this.isUnavailableArticle() &&
                        !this.props.isTablet() &&
                        !frmapp && (
                          <InViewObserver
                            inViewCallback={() => {
                              analyticsWrapper('ga4', {
                                event: 'user_scroll',
                                type: `scroll-depth`,
                                category: 'articleshow_scroll',
                                label: 'article_content_end',
                              });
                            }}
                            viewMargin="100px 0px 100px 0px"
                          >
                            <ElementInView
                              gaLabel={
                                this.props.isEtimesArticle
                                  ? 'top-comment_view'
                                  : 'comments_view'
                              }
                            >
                              <LoadableComponentLoader
                                loadInView
                                loadableComponentName="TopComment"
                                msid={articleshowData.id}
                                onSidebarOpenClose={this.props.openSidebar}
                                commentsData={this.props.commentsData}
                                commentsCount={this.props.commentsCount}
                                isWapView={false}
                                isTablet={this.props.isTablet}
                                isPrivateUser={this.props.isPrivateUser}
                                commentModeration={this.getCommentModerationData()}
                                commentTextInput={this.commentTextInput}
                                gaCategory={categoryForGA}
                                gaAction={
                                  this.props.isEtimesArticle
                                    ? 'BTF_comments'
                                    : 'click'
                                }
                                gaLabel={
                                  this.props.isEtimesArticle
                                    ? ''
                                    : 'Comments_click'
                                }
                                isEtimesArticle={this.props.isEtimesArticle}
                                placeHolderStyles={{ minHeight: '75px' }}
                              />
                            </ElementInView>
                          </InViewObserver>
                        )}
                      {!this.isUnavailableArticle() &&
                        this.props.isTablet() &&
                        !this.isUnavailableArticle() && (
                          <WithCommentLoader
                            msid={this.props.msid}
                            isWapView={this.props.isWapView}
                            commentTextInputRef={this.commentTextInput}
                            seoData={articleshowData.seo}
                            commentModeration={commentModerationVal}
                          />
                        )}
                    </div>
                    <div className={s.end_article}>
                      <span className={s.endArticleText}>End of Article</span>
                    </div>
                    {isThisArticleAdActive &&
                      this.props.articleIndex !== 1 && (
                        <AdCaller
                          skipReRender
                          adWapperClass={s.sponser_bottom_ad}
                          data={{
                            name: 'mgid_with_tower',
                            articleIndex: this.props.articleIndex,
                          }}
                          msid={this.props.msid}
                          className={isMgidCountry ? '' : s.bottom_mgidin_ad}
                        />
                      )}
                    {articleshowData &&
                      articleshowData.latestMobileWidget &&
                      articleshowData.latestMobileWidget.items &&
                      Array.isArray(articleshowData.latestMobileWidget.items) &&
                      articleshowData.latestMobileWidget.items.length > 0 && (
                        <ErrorBoundary>
                          <ProductSliderWrapper
                            title={articleshowData.latestMobileWidget.name}
                            ga4Type={articleshowData.latestMobileWidget.ga4Type}
                            path={articleshowData.latestMobileWidget.path}
                            items={articleshowData.latestMobileWidget.items}
                          />
                        </ErrorBoundary>
                      )}
                    {!(
                      isReviewsPage ||
                      isMspArticle ||
                      articleshowData.ag === 'SPOTLIGHT'
                    ) &&
                      !skipPersonalizationWidget && (
                        <PersonaliseWidget
                          card="readNextColumnVariant"
                          section={this.getSectionName() || ''}
                          subsection={_get(
                            this.props.articleData?.navsubsecs?.subsec2,
                            'subsecname2',
                            '',
                          )}
                          msid={this.props.msid}
                          template="AS"
                          contentprimestatus="non-prime"
                          userprimestatus={
                            this.props.isUserPrime ? 'prime' : 'non-prime'
                          }
                          styleObj={{ minHeight: '356px' }}
                          classname="readnextshimmer"
                        />
                      )}
                    {!this.isUnavailableArticle() &&
                      !(isReviewsPage || isMspArticle) && (
                        <div
                          className={s.bottom_socialwidget}
                          data-bottomsocialshare={articleshowData.id}
                        >
                          <span className={s.inlineshare_heading}>
                            FOLLOW US ON SOCIAL MEDIA
                          </span>
                          <LoadableComponentLoader
                            loadInView
                            loadableComponentName="SocialSharingWeb"
                            hideSharingButtons
                            showFollowButtons
                            isWapView={false}
                            isTablet={this.props.isTablet}
                            type="BTF"
                            gaCategory={categoryForGA}
                            gaAction="click"
                            gaIndex="btfFollow_"
                            textRequired
                            sectionName={sectionName.toLowerCase()}
                            isEtimes={this.props.isEtimesArticle}
                            placeHolderStyles={{ minHeight: '24px' }}
                            placeHolderLoaderClass="follow_us_loader"
                            ga4Data={[
                              {
                                event: 'user_click',
                                type: 'social_share',
                                category: 'bottom_social',
                              },
                            ]}
                          />
                        </div>
                      )}
                    {(articleshowData.ag === 'Brandwire' ||
                      articleshowData.icon === 'smiley') &&
                    articleshowData.advertorial &&
                    articleshowData.advertorial.disclaimer ? (
                      <div
                        className={s.disclaimer_inbottom}
                        // eslint-disable-next-line react/no-danger
                      >
                        <h4>Disclaimer</h4>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: unescape(
                              articleshowData.advertorial.disclaimer,
                            ),
                          }}
                        />
                      </div>
                    ) : null}

                    {/* <div className={s.end_article}>
                      <span>end of article</span>
                    </div> */}
                    {/* <div>
                      <BlockedNotificationCard url={articleshowData.wu} />
                    </div> */}
                    {/* {this.isValidToShowAffiliateWidget() && (
                      <div className={s.timesbetter_banner}>
                        <Links
                          target="_blank"
                          to="https://timesofindia.indiatimes.com/business/tax-calculator"
                        >
                          <ImageElement
                            src="https://static.toiimg.com/photo/97303960.cms"
                            height="164"
                            alt="Budget 2023"
                            lazyload
                          />
                        </Links>
                      </div>
                    )} */}
                    {!isMspArticle && this.getVisualStories(subSecSeoLocation)}
                    {/* <ElementInView
                      gaLabel={
                        this.props &&
                        this.props.articleData &&
                        this.props.articleData.wu
                      }
                      gaCategory="TimesBetterIndiaPromo"
                      gaAction="seen"
                    >
                      <div className={s.timesbetter_banner}>
                        <Links
                          target="_blank"
                          to="https://timesofabetterindia.com/big-picture-contest?utm_source=til&utm_medium=til&utm_campaign=toabi "
                          data={{
                            gaCategory: 'TimesBetterIndiaPromo',
                            gaAction: 'click',
                            gaLabel:
                              this.props &&
                              this.props.articleData &&
                              this.props.articleData.wu,
                          }}
                        >
                          <img
                            src="https://static.toiimg.com/photo/93291203.cms"
                            alt=""
                          />
                        </Links>
                      </div>
                    </ElementInView> */}
                    {/* <WithGeo
                  render={({ geoCountry }) => {
                    const country =
                      typeof geoCountry === 'string'
                        ? geoCountry.toUpperCase()
                        : '';
                    if (country !== 'IN') {
                      return this.getAsBriefs();
                    }
                    return null;
                  }}
                /> */}

                    <WithGeo
                      render={({ geoCountry }) => {
                        const country =
                          typeof geoCountry === 'string'
                            ? geoCountry.toUpperCase()
                            : '';
                        if (country !== 'IN') {
                          return this.getOpinionPoll();
                        }
                        return null;
                      }}
                    />

                    {/* add below condition to set affiliate widget position after 4th br */}
                    {/* this.totalBrCount < 4 && */}
                    {/* {this.getAffilateWidget()} */}
                    {!this.isUnavailableArticle() &&
                      this.getCoronaPhotoCarousel(subSecSeoLocation)}
                    {/* {!isMspArticle && this.getGamesData()} */}
                    {!(
                      articleshowData.ag === 'Mediawire' ||
                      articleshowData.ag === 'SPOTLIGHT' ||
                      articleshowData.ag === 'Brandwire' ||
                      this.props.isMspArticle
                    ) &&
                      (articleshowData &&
                        articleshowData?.trendingBottomWidgetLinks &&
                        Array.isArray(
                          articleshowData.trendingBottomWidgetLinks.items,
                        ) &&
                        articleshowData.trendingBottomWidgetLinks.items
                          .length) && (
                        <LinksList
                          articletrendinglist
                          sectionData={trendingBottomWidgetLinks}
                          heading={
                            articleshowData.trendingBottomWidgetLinks
                              .widgetTitle
                          }
                          key="budgetkeywords"
                          ga4Type={trendingBottomWidgetLinks?.ga4Type}
                        />
                      )}

                    {trendingTopicLinkslist &&
                      Array.isArray(trendingTopicLinkslist) &&
                      trendingTopicLinkslist.length > 0 && (
                        <LinksList
                          articletrendinglist
                          sectionData={trendingTopicLinkslist[0]}
                          key="trendingTopicLinkslist"
                          ga4Type={trendingTopicLinkslist[0]?.ga4Type}
                        />
                      )}
                    {/* {_get(
                    articleshowData,
                    `ads.ctn.slots.NativeBottomVideo.slotId`,
                  ) ? (
                    <div className={s.mobile_ads}>
                      <AdCaller
                        data={{
                          adCode: _get(
                            articleshowData,
                            `ads.ctn.slots.NativeBottomVideo.slotId`,
                          ),
                          msid,
                          breadCrumb: breadCrumbString,
                        }}
                        isCTN
                      />
                    </div>
                  ) : (
                    this.getRecommendedWidgets()
                  )} */}
                    {/* <CampaignBanner /> */}
                    {/*
            */}
                    {/* {!this.props.isWapView && !this.isUnavailableArticle() ? (
              <TimesTop10 />
            ) : null} */}
                    {_get(ctn, 'slots.NativePrime.slotId') && (
                      // Serving prime static banner through CTN AD
                      <AdCaller
                        pauseAdCall={this.props.blocked !== -1}
                        data={{
                          adCode: _get(ctn, 'slots.NativePrime.slotId'),
                          msid,
                          breadCrumb: breadCrumbString,
                        }}
                        isCTN
                      />
                    )}
                    {/* {typeof amazonNsaAd === 'string' &&
                    !this.props.perpetual && <AmazonNSA adCode={amazonNsaAd} />} */}
                    {/**
                     * Commented this as per email subject: Re: Disclaimer in TNN copies
                     */}
                    {/* {
                    articleshowData.metaInfo &&
                    articleshowData.metaInfo.AutoFeedIngestion === '1.0' &&
                    articleshowData.ag !== 'TNN' &&
                    articleshowData.ag !== 'Brandwire' &&
                    articleshowData.ag !== 'Mediawire' &&
                    articleshowData.ag !== 'Colombia' && (
                      <div className="test">
                        (This story has not been edited by timesofindia.com and
                        is auto–generated from a syndicated feed we subscribe
                        to.)
                      </div>
                    )} */}
                  </div>

                  {/* {this.getReadAlsoWidget()} */}
                </div>
              </div>
            </div>
            {!(removeLHSandRHS || isReviewsPage) && (
              <div
                className={`${s.right} article_rhs ${this.getSectionName()} ${
                  this.state.experimentSidebarData ? `sticky-topstories` : ``
                }`}
              >
                {/* {!this.props.isEtimesArticle &&
                  !isMspArticle && (
                    <ErrorBoundary>
                      <LoadableComponentLoader
                        loadInView
                        loadableComponentName="IPLWidget"
                        dataUrl={LIVE_SCORE_CARD_API}
                        msid={this.props.msid}
                        isLiveScoreWidget
                        autoRefresh
                        isLiveIccIplWpl
                        gaData="Scorecard_widget|click_web|Articleshow"
                        gaViewData={[
                          'Scorecard_widget',
                          'view_web',
                          'Articleshow',
                        ]}
                      />
                    </ErrorBoundary>
                  )} */}
                <Sidebar
                  data={
                    this.state.experimentSidebarData ||
                    this.props.sidebarData ||
                    []
                  }
                  isMspArticle={isMspArticle}
                  rhsWidgetPriority={this.props.rhsWidgetPriorityAS}
                  msid={articleshowData.id}
                  currentCountry={this.props.currentCountry}
                  breadCrumbString={breadCrumbString}
                  gaPrefix="RHS"
                  sidebarMapping={sidebarMapping}
                  firstNonAdWidget={firstNonAdWidget}
                  widgetCss={s.widgetPadding}
                  electionFlag={electionFlag}
                  gaCategory={categoryForGA}
                  articleIndex={this.props.articleIndex}
                  gaAction="click"
                  gaLabel=""
                  secName={this.getSectionName()}
                  isUserPrime={this.props.isUserPrime}
                  AffiliateRHSWidget={this.AffiliateRHSWidget()}
                  AstroTalkRHSWidget={this.getAstroTalkRHSWidget()}
                  OpenMindAstroRHSWidget={this.getOpenMindAstroRHSWidget()}
                  stickySideBarClasses={{
                    sticky: s.stickySidebar,
                    stickyWithoutHeader: s.stickySidebarWithoutHeader,
                  }}
                  // stickyCss={
                  //   this.props.isStickyHeaderVisible
                  //     ? s.stickySidebar
                  //     : s.stickySidebarWithoutHeader
                  // } this property will read in sidebar itself
                  isRHSWidgetAS
                  isAdRemoved={this.props.isAdRemoved}
                  rhsWidgetVideoAS={this.props.rhsWidgetVideoAS}
                  subSecSeoLocation={subSecSeoLocation}
                  isPerpetual={perpetual}
                  pageUrl={this.props.articleData.wu}
                  isEtimes={this.props.isEtimesArticle}
                  spotlightSpecificAds={this.props.spotlightSpecificAds}
                />
              </div>
            )}
          </div>
          <InViewObserver
            inViewCallback={() => {
              analyticsWrapper('ga4', {
                event: 'user_scroll',
                type: `scroll-depth`,
                category: 'articleshow_scroll',
                label: 'article_page_end',
              });
            }}
            viewMargin="100px 0px 100px 0px"
          >
            <div id={`liner-${articleshowData.id}`} />
          </InViewObserver>
        </div>
        {/* Ends- Articleshow Main Body Wrapper */}

        <div className={`${s.main_content} clearfix`}>
          <div
            className={`${s.as_heading_wrapper} ${
              this.isUnavailableArticle() ? s.forceHide : ''
            }`}
          >
            <>
              {articleshowData.ag !== 'Brandwire' &&
              !isMspArticle &&
              articleshowData.advertorial &&
              articleshowData.advertorial.disclaimer ? (
                <div
                  className={`${s.disclaimer_inbottom} ${
                    articleshowData.contentType
                      ? s[articleshowData.contentType]
                      : s.bottom_disclaimertxt
                  }`}
                  dangerouslySetInnerHTML={{
                    __html: unescape(articleshowData.advertorial.disclaimer),
                  }}
                />
              ) : null}
            </>
            {/* <div className={s.wrapper}>
              {!(
                articleshowData.id === '70005708' ||
                articleshowData.id === '70065953' ||
                articleshowData.id === '70065881'
              ) && (
                <StickyDiv
                  stickyClass={`${s.sticky} sticky`}
                  outerContainerClass={`${s.nextASwidget} socialwidget`}
                  //appclass={s.appview}
                  offsetFromTop={50}
                  activeMsid={this.props.activeMsid}
                  msid={articleshowData.id}
                  removeStickyClass="remove-sticky"
                />
              )}
            </div> */}
          </div>

          {/*@todo Ask this ad in feed. Do not show the 'For around the Web' ad for first two articles in India section */}
          {/* {!isMspArticle &&
            !frmapp && (
              <BottomAdLayer
                articleData={this.props.articleData}
                msid={this.props.msid}
                isWapView={this.props.isWapView}
                abTestExperimentId={this.props.abTestExperimentId}
                abAdskey={this.props.abAdskey}
                breadCrumbString={breadCrumbString}
                checkGeoForMGID={this.checkGeoForMGID}
              />
            )} */}
          {/* {esiHtmlSnippet && (
            <div id="esi_includes" dangerouslySetInnerHTML={esiHtmlSnippet} />
          )} */}
          <div />
          {!frmapp &&
            !isMspArticle &&
            articleshowData.ag &&
            articleshowData.ag.toLowerCase() === 'brandwire' &&
            this.props.commentsData &&
            this.props.commentsData[0] &&
            this.props.commentsData[0].topComment && (
              <BrandwireComments
                commentsData={this.props.commentsData[0].topComment}
                isWapView={this.props.isWapView}
              />
            )}

          {!this.props.isTablet() &&
            !this.isUnavailableArticle() && (
              <div id={`comment-sidebar-${this.props.msid}`}>
                <WithCommentLoader
                  msid={this.props.msid}
                  isWapView={this.props.isWapView}
                  commentTextInputRef={this.commentTextInput}
                  seoData={articleshowData.seo}
                  commentModeration={commentModerationVal}
                  hideBottomComments
                />
              </div>
            )}
          {/* {articleshowData.moreInToi && (
            <MoreFromToi
              moreFromToidata={articleshowData.moreInToi}
              isWapView={this.props.isWapView}
            />
          )} */}
          <div data-articlepage-end={this.props.msid} />
        </div>
        {this.state.onScrollScripts.size !== 0 && (
          <LoadableComponentLoader
            loadOnScroll
            loadableComponentName="ScriptLoader"
            scripts={this.state.onScrollScripts}
          />
        )}
      </>
    );
  }
}

const mapDispatchtoProps = dispatch => ({
  loadAllAdsFromQueue: (params, path) => {
    dispatch(loadAllAdsFromQueue(params, path));
  },
  setSaleNudgeVisibilityFn: status => {
    dispatch(setSaleNudgeVisibility(status));
  },
});

const mapStateToProps = state => ({
  sidebarData: state.sidebar ? state.sidebar.data : {},
  miniTv: state.miniTv || {},
  clientSideJpodCard: state.articleshow_v2
    ? state.articleshow_v2.cardsInsertsLite
    : {},
  isOrganic: state.articleshow_v2.isOrganic,
  isPaidTraffic: state.articleshow_v2.isPaidTraffic,
  electionTabs: state.common?.siteConfig?.electionTabs,
  isPowerByAdActive: _get(
    state,
    'common.siteConfig.revenue.electionPowerby.isAdActive',
    0,
  ),
  // cardsData: _get(state, 'readnextbundle.readNextCards', {}),
  // personalizeWidgetData: _get(state, 'personalizeData.widgetData', {}),
});

ArticleshowInner.propTypes = {
  isWapView: PropTypes.bool,
  msid: PropTypes.string.isRequired,
  isMiniView: PropTypes.bool,
  isAppView: PropTypes.bool,
  articleData: PropTypes.shape({}).isRequired,
  commentsCount: PropTypes.number.isRequired,
  commentsData: PropTypes.arrayOf(PropTypes.shape({})),
  openSidebar: PropTypes.func.isRequired,
  adsCampaignStatus: PropTypes.shape({}),
  isUserLoggedin: PropTypes.bool.isRequired,
  showLogin: PropTypes.func.isRequired,
  isUserPrime: PropTypes.bool,
  isTablet: PropTypes.func.isRequired,
  loadVideoTheatreSlider: PropTypes.func.isRequired,
  query: PropTypes.shape({}),
  videoTheatreSliderData: PropTypes.arrayOf({}),
  addNextVideoMsid: PropTypes.func.isRequired,
  isPrivateUser: PropTypes.bool,
  perpetual: PropTypes.bool,
  // exitPollData: PropTypes.shape({}).isRequired,
  electionsData: PropTypes.shape({}).isRequired,
  currentCountry: PropTypes.string,
  parentStory: PropTypes.shape({}).isRequired,
  nextStories: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  changeActiveArticle: PropTypes.func.isRequired,
  allArticlesData: PropTypes.arrayOf({}).isRequired,
  sidebarData: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  blocked: PropTypes.number,
  handleBlockerScreenLogin: PropTypes.func,
  ExternalClass: PropTypes.string,
  cssObject: PropTypes.shape({}),
  electionFlag: PropTypes.bool,
  categoryForGA: PropTypes.string,
  sectionName: PropTypes.string,
  articleIndex: PropTypes.number,
  clientSideJpodCard: PropTypes.shape({}),
  loadAllAdsFromQueue: PropTypes.func.isRequired,
  hasFixedHeading: PropTypes.bool,
  removeAffiliateWidget: PropTypes.bool,
  isMspArticle: PropTypes.bool,
  isOrganic: PropTypes.bool,
  isMspUSPage: PropTypes.bool,
  isCityArticle: PropTypes.bool,
  isPaidTraffic: PropTypes.bool,
  abAdskey: PropTypes.string,
  abTestExperimentId: PropTypes.shape({}),
  rhsWidgetPriorityAS: PropTypes.shape({}),
  // isStickyHeaderVisible: PropTypes.bool,
  preloadedLeadImageHref: PropTypes.string,
  isAdRemoved: PropTypes.bool,
  setSaleNudgeVisibilityFn: PropTypes.func.isRequired,
  rhsWidgetVideoAS: PropTypes.bool,
  isPerpetual: PropTypes.bool,
  ag: PropTypes.string,
  isEtimesArticle: PropTypes.bool,
  loadedMiniTvComponent: PropTypes.bool,
  showMiniTvPlayer: PropTypes.func,
  isSPOTLIGHTArticle: PropTypes.bool,
  spotlightSpecificAds: PropTypes.bool,
  isSportsBeaconJs: PropTypes.bool,
};

ArticleshowInner.defaultProps = {
  isWapView: false,
  isMiniView: false,
  isAppView: false,
  commentsData: [],
  adsCampaignStatus: undefined,
  isUserPrime: false,
  query: {},
  videoTheatreSliderData: undefined,
  isPrivateUser: true,
  perpetual: false,
  currentCountry: '',
  blocked: 0,
  handleBlockerScreenLogin: () => {},
  ExternalClass: '',
  cssObject: {},
  electionFlag: false,
  categoryForGA: '',
  sectionName: '',
  articleIndex: 0,
  clientSideJpodCard: {},
  hasFixedHeading: false,
  removeAffiliateWidget: false,
  isMspArticle: false,
  abAdskey: '',
  abTestExperimentId: {},
  isOrganic: false,
  isMspUSPage: false,
  isCityArticle: false,
  isPaidTraffic: false,
  rhsWidgetPriorityAS: undefined,
  // isStickyHeaderVisible: false,
  preloadedLeadImageHref: '',
  isAdRemoved: false,
  rhsWidgetVideoAS: true,
  isPerpetual: false,
  ag: '',
  isEtimesArticle: false,
  loadedMiniTvComponent: false,
  showMiniTvPlayer: undefined,
  isSPOTLIGHTArticle: false,
  spotlightSpecificAds: false,
  isSportsBeaconJs: false,
};

export default connect(mapStateToProps, mapDispatchtoProps)(ArticleshowInner);
